// Russian translations
export const ru: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Панель управления',
  'menu.orderNew': 'Новый заказ',
  'menu.deliveryList': 'Список доставок',
  'menu.delivery': 'Доставка',
  'menu.receipt': 'Печать квитанции',
  
  // Definitions
  'menu.definitions': 'Определения',
  'menu.customers': 'Клиенты',
  'menu.products': 'Определения товаров',
  'menu.pricing': 'Определения цен',
  'menu.tailoring': 'Ателье',
  'menu.attributes': 'Атрибуты товаров',
  'menu.users': 'Пользователи',
  'menu.productOrdering': 'Сортировка товаров',
  'menu.discounts': 'Определения скидок',
  
  // Settings
  'menu.settings': 'Настройки',
  'menu.generalSettings': 'Общие настройки',
  'menu.permissions': 'Управление правами',
  'menu.subscription': 'Подписка',
  'menu.invoices': 'Управление счетами',
  'menu.expenses': 'Расходы',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Отчёты и бухгалтерия',
  'menu.systemAndCommunication': 'Система и связь',
  'menu.reportsList': 'Список квитанций',
  'menu.accountStatement': 'Выписка по счету',
  'menu.tickets': 'Обращения в поддержку',
  'menu.support': 'Поддержка',
  'menu.profile': 'Профиль',
  'menu.logout': 'Выход',
  'menu.notifications': 'SMS/WhatsApp уведомления',
  'menu.whatsappConnection': 'Подключение WhatsApp',
  'menu.smsConnection': 'Подключение SMS',
  
  // Dashboard
  'dashboard.title': 'Панель управления',
  'dashboard.todaySales': 'Продажи сегодня',
  'dashboard.totalOrders': 'Всего заказов',
  'dashboard.pendingDeliveries': 'Ожидающие доставки',
  'dashboard.activeCustomers': 'Активные клиенты',
  'dashboard.recentOrders': 'Последние заказы',
  'dashboard.viewAll': 'Посмотреть все',
  'dashboard.quickActions': 'Быстрые действия',
  'dashboard.newOrder': 'Новый заказ',
  'dashboard.newCustomer': 'Новый клиент',
  'dashboard.deliveries': 'Доставки',
  'dashboard.reports': 'Отчеты',
  'dashboard.today': 'Сегодня',
  'dashboard.yesterday': 'Вчера',
  'dashboard.week': 'Неделя',
  'dashboard.month': 'Месяц',
  'dashboard.quarter': 'Квартал',
  'dashboard.year': 'Год',
  'dashboard.totalRevenue': 'Общая выручка',
  'dashboard.totalPieces': 'Всего предметов',
  'dashboard.cancelled': 'Отменено',
  'dashboard.inProcess': 'В обработке',
  'dashboard.inProcessDesc': 'Заказы в обработке',
  'dashboard.ready': 'Готово',
  'dashboard.readyDesc': 'Готово к доставке',
  'dashboard.delivered': 'Доставлено',
  'dashboard.deliveredDesc': 'Выполненные заказы',
  'dashboard.announcements': 'Объявления',
  'dashboard.announcementAll': 'Общие',
  'dashboard.announcementPrivate': 'Личные',
  
  // Service Types
  'service.tailor': 'Ателье',
  'service.dryCleaning': 'Химчистка',
  'service.washing': 'Стирка',
  'service.ironing': 'Глажка',
  'service.dyeing': 'Покраска',
  'service.shoeShine': 'Чистка обуви',
  'service.carpet': 'Ковер',
  'service.tailoring': 'Ремонт одежды',
  'service.carpetWashing': 'Чистка ковров',
  'service.sofaWashing': 'Чистка диванов',
  'service.carWash': 'Мойка авто и детейлинг',
  'service.selectService': 'Выберите услугу',
  'service.addToCart': 'Добавить в корзину',
  'service.total': 'Итого',
  
  // Order Create Page
  'orderCreate.cart': 'Корзина',
  'orderCreate.totalPieces': 'Всего предметов',
  'orderCreate.plannedDelivery': 'Планируемая доставка',
  'orderCreate.payment': 'Оплата',
  'orderCreate.save': 'Сохранить',
  'orderCreate.continue': 'Продолжить',
  // Area Calculation Dialog
  'areaCalculation.title': 'Area Calculation',
  'areaCalculation.carpetCount': '🔢 Carpet Count',
  'areaCalculation.carpetCountPlaceholder': 'How many carpets?',
  'areaCalculation.directInput': '📏 Enter m² Directly',
  'areaCalculation.totalSqM': '📏 Total m² (for {count} carpets)',
  'areaCalculation.exampleSqM': 'Ex: 12.5',
  'areaCalculation.or': 'OR',
  'areaCalculation.width': 'Width (m)',
  'areaCalculation.height': 'Height (m)',
  'areaCalculation.exampleNumber': 'Ex: 4',
  'areaCalculation.calculatedArea': 'Calculated Area:',
  'areaCalculation.perCarpet': 'Per carpet',
  'areaCalculation.total': 'Total',
  'areaCalculation.continue': 'Continue',

  'orderCreate.allCategories': 'Все',
  'orderCreate.selectCustomer': 'Выбрать клиента',
  'orderCreate.selectCustomerPlaceholder': 'Выберите клиента',
  'orderCreate.change': 'Изменить',
  'orderCreate.select': 'Выбрать',
  'orderCreate.balance': 'Баланс',
  'orderCreate.searchCustomer': 'Поиск по имени, телефону или адресу... (пример: иван+79161234567)',
  'orderCreate.newCustomer': 'Новый клиент',
  'orderCreate.customerName': 'Имя Фамилия',
  'orderCreate.customerPhone': 'Телефон',
  'orderCreate.customerEmail': 'Email',
  'orderCreate.customerAddress': 'Адрес',
  'orderCreate.addCustomer': 'Добавить клиента',
  'orderCreate.customer': 'Клиент',
  'orderCreate.serviceType': 'Тип услуги',
  'orderCreate.clickToSelect': 'Нажмите для выбора',
  'orderCreate.deliveryDate': 'Дата доставки',
  'orderCreate.details': 'Детали',
  'orderCreate.itemDetails': 'Детали предмета',
  'orderCreate.tailoringOperations': 'Швейные операции',
  'orderCreate.tailoringTitle': 'Швейные операции',
  'orderCreate.discount': 'Скидка',
  'orderCreate.discountLabel': 'Скидка (%)',
  'orderCreate.debt': 'Долг',
  'orderCreate.credit': 'Кредит',
  'orderCreate.homeDelivery': 'Доставка на дом',
  'orderCreate.homeDeliveryAddress': 'Адрес',
  'orderCreate.addressRequired': 'Требуется адрес!',
  'orderCreate.subtotal': 'Промежуточный итог',
  'orderCreate.grandTotal': 'Общая сумма',
  
  // Products
  'products.title': 'Определения товаров',
  'products.addNew': 'Новый товар',
  'products.category': 'Категория',
  'products.name': 'Название товара',
  'products.price': 'Цена',
  'products.color': 'Цвет',
  'products.active': 'Активный',
  'products.actions': 'Действия',
  'products.search': 'Поиск товара...',
  'products.noProducts': 'Товары не найдены',
  'products.noCategoryProducts': 'В этой категории товары не найдены',
  'products.emptyCart': 'Корзина пуста',
  
  // Customers
  'customers.title': 'Клиенты',
  'customers.addNew': 'Новый клиент',
  'customers.search': 'Поиск клиентов...',
  'customers.name': 'Имя',
  'customers.phone': 'Телефон',
  'customers.email': 'Email',
  'customers.address': 'Адрес',
  'customers.balance': 'Баланс',
  'customers.actions': 'Действия',
  'customers.edit': 'Редактировать',
  'customers.delete': 'Удалить',
  'customers.noCustomers': 'Клиенты не найдены',
  'customers.tableCustomer': 'Клиент',
  'customers.tableContact': 'Контакт',
  'customers.tableAddress': 'Адрес',
  'customers.tableNotifications': 'Уведомления',
  'customers.tableBalance': 'Баланс',
  'customers.tableActions': 'Действия',
  'customers.totalCount': 'Всего {count} клиентов',
  'customers.notes': 'Примечание',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Поиск по имени, телефону, email или адресу... (пример: иван+79161234567)',
  'customers.updated': 'Клиент обновлен',
  'customers.updateError': 'Не удалось обновить клиента',
  'customers.added': 'Клиент добавлен',
  'customers.addError': 'Не удалось добавить клиента',
  'customers.deleted': 'Клиент удален',
  'customers.deleteError': 'Не удалось удалить клиента',
  'customers.deleteConfirm': 'Вы уверены, что хотите удалить клиента "{name}"?',
  'customers.loadError': 'Не удалось загрузить клиентов',
  'customers.noResults': 'Результаты не найдены',
  'customers.showingFirst50': 'Показаны первые 50 результатов',
  'customers.totalResults': 'всего',
  
  // Users
  'users.title': 'Пользователи',
  'users.addNew': 'Новый пользователь',
  'users.name': 'Полное имя',
  'users.email': 'Email',
  'users.role': 'Роль',
  'users.pin': 'PIN',
  'users.permissions': 'Права',
  'users.allPermissions': 'Все права',
  'users.permissionCount': '{count} прав',
  'users.changePin': 'Изменить PIN',
  'users.edit': 'Редактировать',
  'users.newUser': 'Новый пользователь',
  'users.editUser': 'Редактировать пользователя',
  'users.editingUser': 'Редактирование пользователя {name}',
  'users.pinCode': 'PIN-код (4-6 цифр)',
  'users.selectRole': 'Выберите роль',
  'users.patron': 'Владелец',
  'users.kasiyer': 'Кассир',
  'users.sofor': 'Водитель',
  'users.eleman': 'Сотрудник',
  'users.changePinTitle': 'Изменить PIN-код',
  'users.newPin': 'Новый PIN-код',
  'users.confirmPin': 'Подтвердите PIN-код',
  'users.pinMismatch': 'PIN-коды не совпадают',
  'users.pinRequired': 'PIN-код обязателен',
  'users.pinLength': 'PIN-код должен быть 4-6 цифр',
  'users.changingPinFor': 'Изменение PIN-кода для {name}',
  
  // Pricing Page
  'pricing.title': 'Определения цен',
  'pricing.search': 'Поиск товара...',
  'pricing.product': 'Товар',
  'pricing.dryCleaning': 'Химчистка',
  'pricing.washing': 'Стирка',
  'pricing.ironing': 'Глажка',
  'pricing.dyeing': 'Покраска',
  'pricing.tailoring': 'Ремонт одежды',
  'pricing.shoeShine': 'Чистка обуви',
  'pricing.action': 'Действие',
  'pricing.save': 'Сохранить',
  'pricing.saving': 'Сохранение',
  'pricing.pricesSaved': 'Цены сохранены',
  'pricing.pricesSaveError': 'Не удалось сохранить цены',
  'pricing.noProducts': 'Товары не найдены',
  'pricing.loadError': 'Не удалось загрузить товары',
  
  // Tailoring Page
  'tailoring.title': 'Швейные операции',
  'tailoring.addNew': 'Новая операция',
  
  // Attributes Page
  'attributes.title': 'Атрибуты товаров',
  'attributes.colors': 'Цвета',
  'attributes.stains': 'Типы пятен',
  'attributes.damages': 'Типы повреждений',
  'attributes.add': 'Добавить',
  
  // Permissions Page
  'permissions.title': 'Управление правами',
  'permissions.subtitle': 'Установите права для ролей владельца и кассира',
  'permissions.about': 'О управлении правами',
  'permissions.patronInfo': '<strong>Владелец:</strong> Главная роль администратора со всеми правами системы.',
  'permissions.cashierInfo': '<strong>Кассир:</strong> Роль пользователя с ограниченными правами для повседневных операций.',
  'permissions.saveSuccess': 'Права сохранены',
  'permissions.saveError': 'Не удалось сохранить права',
  'permissions.patron': 'Владелец',
  'permissions.cashier': 'Кассир',
  'permissions.patronRole': 'Полный доступ администратора',
  'permissions.cashierRole': 'Ограниченный доступ пользователя',
  'permissions.activePermissions': 'Активные права:',
  'permissions.selectAllPatron': 'Выбрать все для владельца',
  'permissions.deselectAllPatron': 'Снять все для владельца',
  'permissions.selectAllCashier': 'Выбрать все для кассира',
  'permissions.deselectAllCashier': 'Снять все для кассира',
  'permissions.saving': 'Сохранение...',
  'permissions.permissionList': 'Список прав',
  'permissions.infoTitle': 'О управлении правами',
  'permissions.infoText1': 'Главная роль администратора со всеми правами системы.',
  'permissions.infoText2': 'Роль пользователя с ограниченными правами для повседневных операций.',
  'permissions.infoText3': 'Изменения вступят в силу только после сохранения.',
  'permissions.infoText4': 'Права могут быть настроены для каждой роли.',
  
  // Driver Dashboard Page
  'driver.title': 'Панель водителя',
  'driver.todayRevenue': 'Выручка сегодня',
  'driver.totalPieces': 'Всего предметов',
  'driver.pending': 'Ожидает',
  'driver.ready': 'Готово',
  'driver.pickup': 'Забрать',
  'driver.delivery': 'Доставка',
  
  // Subscription Page
  'subscription.title': 'Планы подписки',
  'subscription.currentPlan': 'Ваш текущий план',
  'subscription.upgradePlan': 'Повысить',
  'subscription.downgradePlan': 'Понизить',
  'subscription.choosePlan': 'Выбрать план',
  'subscription.billingCycle': 'Цикл оплаты',
  'subscription.monthly': 'Ежемесячно',
  'subscription.yearly': 'Ежегодно',
  'subscription.perMonth': '/месяц',
  'subscription.perYear': '/год',
  'subscription.plusVAT': '+ НДС',
  'subscription.save': 'Сэкономьте {percent}%',
  'subscription.mostPopular': 'Самый популярный',
  'subscription.freeTrial': '{months} месяц бесплатно',
  'subscription.featuresIncluded': 'Включенные функции:',
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Идеально для малых предприятий',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Для растущих компаний',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Корпоративные решения',
  'subscription.maxReceipts': 'Максимум {count} чеков/месяц',
  'subscription.maxUsers': '{count} учетных записей пользователей',
  'subscription.whatsappCredits': '🎁 {count} кредитов WhatsApp в подарок',
  'subscription.basicReports': 'Базовые отчеты',
  'subscription.advancedReports': 'Расширенные отчеты',
  'subscription.customReports': 'Пользовательские отчеты',
  'subscription.whatsappIntegration': 'Интеграция WhatsApp',
  'subscription.supportTicket': 'Время ответа на тикет: {hours} часов',
  'subscription.supportTicketBusiness': 'Время ответа на тикет: {hours} часов (рабочее время)',
  'subscription.accountManagement': 'Управление аккаунтом',
  'subscription.driverApp': 'Мобильное приложение водителя',
  'subscription.prioritySupport': 'Приоритетная поддержка',
  'subscription.managerApp': 'Мобильное приложение - вид менеджера',
  'subscription.paymentTitle': 'Завершить оплату',
  'subscription.planSelection': 'Выбранный план',
  'subscription.billingPeriod': 'Период оплаты',
  'subscription.month': 'месяц',
  'subscription.year': 'год',
  'subscription.subtotal': 'Промежуточный итог',
  'subscription.tax': 'НДС ({rate}%)',
  'subscription.total': 'Итого',
  'subscription.couponCode': 'Промокод',
  'subscription.applyCoupon': 'Применить',
  'subscription.removeCoupon': 'Удалить',
  'subscription.discount': 'Скидка',
  'subscription.invalidCoupon': 'Неверный промокод',
  'subscription.couponVerificationFailed': 'Проверка купона не удалась',
  'subscription.couponRemoved': 'Купон удален',
  'subscription.billingInfo': 'Платежная информация',
  'subscription.companyName': 'Название компании',
  'subscription.companyNamePlaceholder': 'Введите название компании',
  'subscription.taxNumber': 'ИНН',
  'subscription.taxNumberPlaceholder': 'Введите ИНН',
  'subscription.phone': 'Телефон',
  'subscription.phonePlaceholder': 'Введите номер телефона',
  'subscription.address': 'Адрес',
  'subscription.addressPlaceholder': 'Введите адрес для выставления счета',
  'subscription.corporateInvoice': 'Корпоративный счет',
  'subscription.individualInvoice': 'Индивидуальный счет',
  'subscription.paymentMethod': 'Способ оплаты',
  'subscription.creditCard': 'Кредитная карта',
  'subscription.bankTransfer': 'Банковский перевод',
  'subscription.cardNumber': 'Номер карты',
  'subscription.cardNumberPlaceholder': 'Введите номер карты',
  'subscription.expiryDate': 'Срок действия',
  'subscription.cvc': 'CVC',
  'subscription.completePayment': 'Завершить оплату',
  'subscription.processing': 'Обработка...',
  'subscription.redirectingToPayment': 'Перенаправление на страницу оплаты...',
  'subscription.paymentSuccess': '✅ Оплата прошла успешно! Ваша подписка активирована.',
  'subscription.paymentCompleted': '🎉 Оплата успешно завершена!',
  'subscription.paymentCancelled': '❌ Оплата отменена.',
  'subscription.paddleTestCards': 'Тестовые карты Paddle выведены в консоль! (F12)',
  'subscription.sandboxTestCards': '🎴 ТЕСТОВЫЕ КАРТЫ (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ УСПЕШНЫЕ ТЕСТОВЫЕ КАРТЫ:',
  'subscription.failedPaymentCards': '❌ НЕУДАЧНЫЕ ТЕСТОВЫЕ КАРТЫ:',
  'subscription.invalidCard': '📌 Недействительная карта:',
  'subscription.sandboxOnly': '📝 ПРИМЕЧАНИЕ: Эти карты работают только в среде Sandbox!',
  'subscription.enterCompanyName': 'Введите название компании',
  'subscription.enterPhone': 'Введите номер телефона',
  'subscription.enterTaxNumber': 'Введите ИНН',
  'subscription.selectPackage': 'Пожалуйста, выберите пакет',
  'subscription.selectPlan': 'Пожалуйста, выберите план',
  'subscription.paddleNotLoaded': 'SDK Paddle еще не загружен. Пожалуйста, перезагрузите страницу.',
  'subscription.paymentError': 'Ошибка оплаты: ',
  'subscription.paymentCreationFailed': 'Не удалось создать платеж. Проверьте журналы консоли.',
  'subscription.paddleConfigurationMissing': '⚠️ Конфигурация Paddle отсутствует!',
  'subscription.paddleDashboardRequired': '⚠️ Требуется настройка панели Paddle!',
  'subscription.paddleApiNotConfigured': 'API-ключ Paddle не настроен. Обратитесь к администратору.',
  'subscription.cancelConfirm': 'Вы уверены, что хотите отменить подписку? Ваш сервис продолжится до конца расчетного периода.',
  'subscription.cancelSuccess': '✅ Подписка отменена. Ваш сервис продолжится до конца расчетного периода.',
  'subscription.cancelFailed': 'Отмена не удалась',
  'subscription.region.turkey': '🇹🇷 Турция',
  'subscription.region.europe': '🇪🇺 Европа',
  'subscription.region.other': '🌎 Другое',
  'subscription.status': 'Статус',
  'subscription.active': 'Активен',
  'subscription.sandboxMode': '🧪 SANDBOX (Тестовый режим)',
  'subscription.liveMode': '🚀 LIVE (Производственная среда)',
  'subscription.paddleActive': 'Активен',
  'subscription.paddleConfigured': '✅ Да',
  'subscription.paddleNotConfigured': '❌ Нет',
  'subscription.whatsappCreditsTitle': 'Кредиты WhatsApp',
  'subscription.whatsappCreditsPackages': 'Пакеты кредитов',
  'subscription.whatsappCurrentBalance': 'Текущий баланс',
  'subscription.whatsappCreditsAmount': '{count} Кредитов',
  'subscription.whatsappPurchaseCredits': 'Купить кредиты',
  
  // Invoices Page
  'invoices.title': 'Управление счетами',
  'invoices.subtitle': 'Просмотр и загрузка счетов за подписку',
  
  // Common Form Fields
  'form.color': 'Цвет',
  'form.stain': 'Пятно',
  'form.damage': 'Повреждение',
  'form.notes': 'Примечания',
  'form.area': 'Площадь',
  
  // Stain Types
  'stain.blood': 'Кровь',
  'stain.oil': 'Масло',
  'stain.ink': 'Чернила',
  'stain.teaCoffee': 'Чай/Кофе',
  'stain.fruit': 'Фрукты',
  'stain.rust': 'Ржавчина',
  'stain.paint': 'Краска',
  'stain.mud': 'Грязь',
  'stain.salt': 'Соль',
  'stain.none': 'Нет',
  'stain.status': 'Статус пятна',
  'stain.multiple': 'Статус пятна (Множественный выбор)',
  'stain.other': 'Другой тип пятна (Нажмите Enter, чтобы добавить)...',
  
  // Expenses Page
  'expenses.title': 'Ввод расходов',
  'expenses.addNew': 'Новый расход',
  'expenses.total': 'Общие расходы',
  'expenses.totalToday': 'Общие расходы сегодня',
  'expenses.deletePermission': 'ℹ️ Удаление расходов разрешено только для роли владельца.',
  'expenses.description': 'Описание',
  'expenses.amount': 'Сумма',
  'expenses.category': 'Категория',
  'expenses.noExpenses': 'Нет записей о расходах за сегодня',
  'expenses.newExpense': 'Новый расход',
  'expenses.descriptionLabel': 'Описание *',
  'expenses.amountLabel': 'Сумма ($) *',
  'expenses.categoryLabel': 'Категория *',
  'expenses.categoryPlaceholder': 'Выберите категорию...',
  'expenses.deleteTitle': 'Удалить расход',
  'expenses.deleteConfirm': 'Вы уверены, что хотите удалить этот расход?',
  'expenses.descriptionField': 'Описание:',
  'expenses.categoryField': 'Категория:',
  'expenses.amountField': 'Сумма:',
  'expenses.dateField': 'Дата:',
  'expenses.cancel': 'Отмена',
  'expenses.yesDelete': 'Да, удалить',
  'expenses.deleting': 'Удаление...',
  'expenses.saved': 'Расход сохранен',
  'expenses.saveError': 'Не удалось сохранить расход',
  'expenses.deleted': 'Расход удален',
  'expenses.deleteError': 'Не удалось удалить расход',
  'expenses.loadError': 'Не удалось загрузить расходы',
  'expenses.dateFilter': 'Фильтр по дате',
  'expenses.showDateFilter': 'Выбрать диапазон дат',
  'expenses.startDate': 'Дата начала',
  'expenses.endDate': 'Дата окончания',
  'expenses.applyFilter': 'Фильтр',
  'expenses.clearFilter': 'Очистить',
  'expenses.activeFilter': 'Активный фильтр',
  'expenses.filterApplied': 'Фильтр по дате применен',
  'expenses.filterCleared': 'Фильтр очищен',
  'expenses.selectBothDates': 'Пожалуйста, выберите обе даты начала и окончания',
  'expenses.canOnlyDeleteToday': 'Вы можете удалять только расходы, введённые сегодня.',
  'expenses.myBranch': 'Мой филиал',
  'expenses.noBranchSelected': '— Филиал не выбран —',
  'expenses.branchSelect': 'Выберите филиал',
  'expenses.excelError': 'Не удалось создать файл Excel',
  'expenses.exportExcel': 'Excel',
  'expenses.records': 'записей',
  'expenses.categoryBy': 'По категориям',
  'expenses.allTypes': 'Все типы',
  'expenses.noBranch': 'Без филиала',
  'expenses.allBranches': 'Все филиалы',
  'expenses.expenseType': 'Тип расхода',
  
  // Delivery List Page
  'deliveryList.title': 'Список доставок',
  'deliveryList.search': 'Номр квитанции, имя клиента или телефон...',
  'deliveryList.all': 'Все',
  'deliveryList.pending': 'Ожидает',
  'deliveryList.ready': 'Готово',
  'deliveryList.date': 'Дата',
  'deliveryList.pieces': 'Предметы',
  'deliveryList.amount': 'Сумма',
  'deliveryList.readyButton': 'Готово',
  'deliveryList.receiptButton': 'Квитанция',
  'deliveryList.noOrders': 'Заказы не найдены',
  'deliveryList.statusUpdated': 'Заказ отмечен как готов',
  'deliveryList.statusUpdateError': 'Не удалось обновить статус',
  'deliveryList.loadError': 'Не удалось загрузить заказы',
  'deliveryList.whatsappSending': '📱 Отправка сообщения WhatsApp...',
  'deliveryList.smsSent': '📨 SMS сообщение отправлено',
  
  // Delivery Page
  'deliveryPage.title': 'Доставка',
  'deliveryPage.search': 'Поиск по номеру квитанции, имени, телефону или адресу...',
  'deliveryPage.pieces': 'Предметы',
  'deliveryPage.amount': 'Сумма',
  'deliveryPage.payment': 'Оплата',
  'deliveryPage.deliverButton': 'Доставить',
  'deliveryPage.noOrdersFound': 'Готовые заказы не найдены',
  'deliveryPage.noReadyOrders': 'Нет заказов, готовых к доставке',
  'deliveryPage.minSearchLength': 'Введите не менее 3 символов для поиска',
  'deliveryPage.paymentDialogTitle': 'Оплата при доставке',
  'deliveryPage.ordersLoadError': 'Не удалось загрузить заказы',
  'deliveryPage.searchError': 'Ошибка поиска',
  'deliveryPage.deliverySuccess': 'Заказ успешно доставлен',
  'deliveryPage.deliveryError': 'Ошибка доставки',
  'deliveryPage.whatsappSending': '📱 Отправка квитанции через WhatsApp...',
  'deliveryPage.statusNotReady': 'Заказ найден, но не готов к доставке',
  'deliveryPage.statusPending': 'Ожидает - Сначала отметьте как готово на странице "Список доставок"',
  'deliveryPage.statusDelivered': 'Доставлено',
  'deliveryPage.statusCancelled': 'Отменено',
  'deliveryPage.receiptDelivered': '✅ *ДОСТАВЛЕНО*',
  
  // Receipt Page
  'receipt.title': 'Квитанция и этикетка',
  'receipt.customerReceipt': 'Квитанция клиента',
  'receipt.back': 'Назад',
  'receipt.print': 'Печать квитанции',
  'receipt.whatsappSend': 'Отправить WhatsApp',
  'receipt.receiptNumber': 'Номер квитанции',
  'receipt.date': 'Дата',
  'receipt.time': 'Время',
  'receipt.product': 'Товар',
  'receipt.quantity': 'Кол-во',
  'receipt.price': 'Цена',
  'receipt.totalPieces': 'Всего предметов',
  'receipt.subtotal': 'Промежуточный итог',
  'receipt.tax': 'НДС',
  'receipt.total': 'ИТОГО',
  'receipt.payment': 'Оплата',
  'receipt.plannedDelivery': 'Планируемая доставка',
  'receipt.notFound': 'Квитанция не найдена',
  'receipt.newOrder': 'Новый заказ',
  'receipt.search': 'Поиск и повторная печать квитанции',
  'receipt.searchPlaceholder': 'Поиск по номеру квитанции, имени клиента или телефону...',
  'receipt.searchEmpty': 'Введите номер квитанции или имя клиента для поиска',
  'receipt.noResults': 'Результаты не найдены',
  'receipt.resultsCount': 'Найдено {count} результатов',
  'receipt.printButton': 'Печать квитанции',
  'receipt.products': 'товары',
  'receipt.loadError': 'Не удалось загрузить данные',
  'receipt.whatsappOpening': 'Открытие WhatsApp...',
  'receipt.labelPrinting': 'Печать этикетки {current}/{total}...',
  'receipt.andLabel': 'и этикетка',
  'receipt.stain': 'Пятно',
  'receipt.damage': 'Повреждение',
  'receipt.taxPercent': 'НДС (20%)',
  'receipt.thankYou': 'Спасибо!',

  // Payment Methods
  'payment.cash': 'Наличные',
  'payment.adjustment': 'Корректировка баланса',
  'payment.card': 'Кредитная карта (POS)',
  'payment.creditCard': 'Кредитная карта',
  'payment.mealCard': 'Карта питания',
  'payment.onDelivery': 'При доставке',
  'payment.account': 'Счет',
  
  // Settings Page
  'settings.title': 'Настройки',
  'settings.general': 'Общие настройки',
  'settings.companyName': 'Название компании',
  'settings.language': 'Язык',
  'settings.currency': 'Валюта',
  'settings.currencyPosition': 'Позиция валюты',
  'settings.currencyPositionLeft': 'Слева ($100.00)',
  'settings.currencyPositionRight': 'Справа (100.00₽)',
  'settings.currencyPositionPreviewLeft': 'Символ слева',
  'settings.currencyPositionPreviewRight': 'Символ справа',
  'settings.numberFormat': 'Формат числа',
  'settings.currencyFormat': 'Формат валюты',
  'settings.showDecimals': 'Показать десятичные',
  'settings.showDecimalsDesc': 'Отображать десятичную часть (копейки) в ценах',
  'settings.dateFormat': 'Формат даты',
  'settings.timezone': 'Часовой пояс',
  'settings.deliveryDays': 'Время доставки (дни)',
  'settings.workOnSunday': 'Работа по воскресеньям',
  'settings.defaultServiceType': 'Тип услуги по умолчанию',
  'settings.defaultServiceTypeDesc': 'Тип услуги, который будет автоматически выбран при открытии экрана ввода товара',
  'settings.defaultCategory': 'Категория по умолчанию',
  'settings.defaultCategoryDesc': 'Категория, которая будет автоматически выбрана при открытии экрана ввода товара',
  'settings.companyLogo': 'Логотип компании',
  'settings.logoDescription': 'Логотип будет отображаться на квитанциях и в левом верхнем углу программы. Рекомендуемый размер: 200x80px',
  'settings.uploadLogo': 'Загрузить логотип',
  'settings.removeLogo': 'Удалить логотип',
  'settings.noLogo': 'Нет логотипа',
  'settings.receiptSettings': 'Настройки квитанции',
  'settings.taxRate': 'Налоговая ставка (%)',
  'settings.receiptFooterText': 'Текст нижнего колонтитула квитанции',
  'settings.receiptNote': 'Нижний колонтитул квитанции (Примечания)',
  'settings.socialMedia': 'Социальные сети и контакты',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Сайт',
  'settings.phone': 'Телефон',
  'settings.address': 'Адрес',
  'settings.dangerZone': 'Опасная зона',
  'settings.deleteDemoDataWarning': 'Удаляются образцы клиентов, добавленные автоматически при настройке, вместе с их квитанциями и платежами. Добавленные вами клиенты и квитанции не удаляются.',
  'settings.productsWillBeKept': 'Определения товаров будут сохранены.',
  'settings.deleteDemoDataTitle': 'Демо-данные будут удалены',
  'settings.deleteDemoDataConfirm': 'Это действие нельзя отменить! Образцы клиентов и их квитанции/платежи будут удалены; ваши клиенты и квитанции сохранятся.',
  'toast.noDemoData': 'Образцы клиентов для удаления не найдены.',
  'toast.demoCustomersKept': 'Карточки образцов клиентов ({n}) сохранены, так как у них есть ваши квитанции; удалены только образцы квитанций.',
  'settings.areYouSure': 'Вы уверены, что хотите продолжить?',
  'settings.deleting': 'Удаление...',
  'settings.yesDelete': 'Да, удалить',
  'settings.deleteDemoData': 'Удалить демо-данные',
  'settings.save': 'Сохранить',
  'settings.loading': 'Загрузка...',
  'settings.languageRegion': 'Язык и регион',
  'settings.numberFormatDotComma': 'Точка для десятичных (1.234,56)',
  'settings.numberFormatCommaDot': 'Запятая для десятичных (1,234.56)',
  'settings.numberFormatSpaceComma': 'Пробел для десятичных (1 234,56)',
  'settings.receiptNotePlaceholder': 'Введите примечание к чеку',
  'settings.companyNamePlaceholder': 'Введите название компании',
  'settings.addressPlaceholder': 'Введите адрес',
  'settings.footerTextPlaceholder': 'Введите текст нижнего колонтитула',
  'settings.loadSchema': 'Загрузить схему',
  'settings.loadSchemaTitle': 'Загрузить схему базы данных',
  'settings.loadSchemaConfirm': 'Это создаст схему базы данных. Продолжить?',
  'settings.connected': 'Подключено',
  'settings.notConnected': 'Не подключено',
  'settings.connect': 'Подключить',
  'settings.disconnect': 'Отключить',
  
  // Toasts
  'toast.settingsSaved': 'Настройки сохранены',
  'toast.settingsError': 'Не удалось сохранить настройки',
  'toast.settingsLoadError': 'Не удалось загрузить настройки',
  'toast.logoUploaded': 'Логотип загружен. Не забудьте сохранить!',
  'toast.logoRemoved': 'Логотип удален. Не забудьте сохранить!',
  'toast.logoSizeError': 'Файл логотипа должен быть меньше 500 КБ',
  'toast.logoTypeError': 'Можно загружать только файлы изображений',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'Подключение WhatsApp',
  'whatsapp.subtitle': 'Управление подключением WhatsApp Business API',
  'whatsapp.connectionStatus': 'Статус подключения',
  'whatsapp.disconnected': 'Отключено',
  'whatsapp.notConnectedMessage': 'Ваш аккаунт WhatsApp еще не подключен',
  'whatsapp.connectWithQR': 'Подключить с помощью QR-кода',
  'whatsapp.importantInfo': 'Важная информация',
  'whatsapp.info1': '1. Отсканируйте QR-код с помощью приложения WhatsApp на вашем телефоне',
  'whatsapp.info2': '2. После подключения вы можете отправлять автоматические сообщения',
  'whatsapp.info3': '3. Чтобы отключиться, выйдите из настроек WhatsApp',
  'whatsapp.info4': '4. QR-код автоматически обновится через 60 секунд',
  'whatsapp.generateQR': 'Создать QR-код',
  
  // Common
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.cancel': 'Отмена',
  'common.confirm': 'Подтвердить',
  'common.delete': 'Удалить',
  'common.edit': 'Редактировать',
  'common.save': 'Сохранить',
  'common.search': 'Поиск',
  'common.loading': 'Загрузка...',
  'common.noData': 'Нет данных',
  'common.actions': 'Действия',
  'common.status': 'Статус',
  'common.date': 'Дата',
  'common.time': 'Время',
  'common.total': 'Итого',
  'common.close': 'Закрыть',
  'common.back': 'Назад',
  'common.submit': 'Отправить',
  'common.create': 'Создать',
  'common.creating': 'Создание...',
  'common.later': 'Позже',
  'common.perPage': 'На страницу',
  'common.page': 'Страница',
  'common.orders': 'Заказы',
  'common.previous': 'Назад',
  'common.next': 'Вперед',
  'common.pieces': 'шт.',
  
  // Tickets
  'tickets.title': 'Обращения в поддержку',
  'tickets.newTicket': 'Новое обращение',
  'tickets.noTickets': 'Пока нет обращений в поддержку',
  'tickets.noTicketsDesc': 'Если у вас возникла проблема, вы можете создать новое обращение в поддержку',
  'tickets.subject': 'Тема',
  'tickets.description': 'Описание',
  'tickets.yourName': 'Ваше имя',
  'tickets.yourNamePlaceholder': 'Введите ваше имя',
  'tickets.subjectPlaceholder': 'Кратко опишите вашу проблему',
  'tickets.descriptionPlaceholder': 'Опишите вашу проблему подробно',
  'tickets.created': 'Обращение в поддержку создано',
  'tickets.createError': 'Не удалось создать обращение в поддержку',
  'tickets.fillAllFields': 'Заполните все поля',
  'tickets.loadError': 'Не удалось загрузить обращения',
  'tickets.messages': 'сообщений',
  'tickets.status.open': 'Открыто',
  'tickets.status.investigating': 'Расследование',
  'tickets.status.waitingCustomer': 'Ожидание клиента',
  'tickets.status.closed': 'Решено',
  'tickets.conversation': 'Беседа',
  'tickets.admin': 'Команда поддержки',
  'tickets.typeMessage': 'Введите ваше сообщение...',
  'tickets.sendError': 'Не удалось отправить сообщение',
  'tickets.closedMessage': 'Это обращение отмечено как решенное.',
  'tickets.rateSupport': 'Оценить поддержку',
  'tickets.rateExperience': 'Оцените ваш опыт',
  'tickets.rateDescription': 'Как бы вы оценили полученную поддержку?',
  'tickets.selectRating': 'Пожалуйста, выберите оценку',
  'tickets.ratingSubmitted': 'Ваша оценка сохранена, спасибо!',
  'tickets.ratingError': 'Не удалось отправить оценку',
  'tickets.yourRating': 'Ваша оценка',
  'tickets.rating.veryBad': 'Очень плохо',
  'tickets.rating.bad': 'Плохо',
  'tickets.rating.okay': 'Нормально',
  'tickets.rating.good': 'Хорошо',
  'tickets.rating.excellent': 'Отлично',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Система управления химчисткой',
  'login.tenantId': 'ID компании',
  'login.tenantPlaceholder': 'id-компании (например: acme-clean)',
  'login.tenantIdHelp': 'Введите ваш уникальный идентификатор компании',
  'login.continue': 'Продолжить →',
  'login.notMember': 'Еще не зарегистрированы?',
  'login.startTrial': 'Начать бесплатный пробный период',
  'login.adminLogin': '🔒 Вход администратора',
  'login.enterPin': 'Введите ваш PIN-код',
  'login.changeTenant': 'Сменить компанию',
  'login.clear': 'Очистить',
  'login.delete': 'Удалить',
  'login.login': 'Войти',
  'login.loggingIn': 'Вход...',
  'login.defaultPinOwner': 'PIN по умолчанию: <strong>1234</strong> (Владелец)',
  'login.defaultPinCashier': 'PIN по умолчанию: <strong>0000</strong> (Кассир)',
  'login.systemInitializing': 'Инициализация системы...',
  'login.pinMinLength': 'PIN должен быть не менее 4 цифр',
  'login.invalidTenantId': 'Введите действительный ID компании',
  'login.tenantNotFound': 'Этот код компании не найден. Пожалуйста, проверьте или создайте новую учетную запись.',
  'login.loginFailed': 'Ошибка входа',
  'login.welcome': 'Добро пожаловать, {name}',

  // Signup translations
  'signup.title': 'Начать бесплатный пробный период',
  'signup.subtitle': 'Попробуйте бесплатно 15 дней, кредитная карта не требуется',
  'signup.backToLogin': 'Вернуться к входу',
  'signup.companyCode': 'Код компании',
  'signup.companyCodePlaceholder': 'например: cleanpro',
  'signup.companyCodeHelp': 'Этот код будет использоваться для входа в систему',
  'signup.companyCodeMinLength': 'Код компании должен быть не менее 3 символов',
  'signup.companyName': 'Название компании',
  'signup.companyNamePlaceholder': 'Название вашей компании',
  'signup.companyNameRequired': 'Название компании обязательно',
  'signup.fullName': 'Полное имя',
  'signup.fullNamePlaceholder': 'Ваше полное имя',
  'signup.fullNameRequired': 'Полное имя обязательно',
  'signup.phone': 'Телефон',
  'signup.phonePlaceholder': '+7 916 123 4567',
  'signup.validPhoneRequired': 'Пожалуйста, введите действительный номер телефона',
  'signup.email': 'Email',
  'signup.emailPlaceholder': 'primer@company.ru',
  'signup.validEmailRequired': 'Пожалуйста, введите действительный адрес email',
  'signup.createAccount': 'Создать учетную запись',
  'signup.creating': 'Создание...',
  'signup.terms': 'Создавая учетную запись, вы соглашаетесь с нашими Условиями использования и Политикой конфиденциальности.',
  'signup.success': 'Регистрация успешна! Данные для входа отправлены на ваш email.',
  'signup.successTitle': 'Регистрация успешна!',
  'signup.successMessage': 'Ваша учетная запись успешно создана.',
  'signup.emailSent': 'Данные для входа отправлены на ваш email.',
  'signup.redirecting': 'Перенаправление на страницу входа...',
  'signup.startupPackageLoaded': 'Стартовый пакет загружен!',
  'signup.products': 'Товар',
  'signup.customers': 'Клиент',
  'signup.users': 'Пользователь',
  'signup.demoDataReady': '✨ Ваши демо-данные готовы, вы можете начать использование немедленно!',
  'signup.loginInfo': '📧 Ваши данные для входа',
  'signup.loginInfoSent': '💡 Эти данные также отправлены на ваш email',
'signup.loginNow': 'Войти сейчас →',
  'signup.hints.companyCode': 'Используется для входа',
  'signup.hints.country': 'Ваша страна определена автоматически. Вы можете выбрать другую страну.',
  'signup.freeTrial': '🎉 Попробуйте бесплатно 15 дней - кредитная карта не требуется!',
  'signup.businessType.question': 'Какой у вас бизнес?',
  'signup.businessType.hint': 'Экран по умолчанию будет настроен автоматически в соответствии с вашим выбором',
  'signup.businessType.continue': 'Продолжить',
  'signup.bt.dryCleaning.desc': 'Чистка одежды, штор и текстиля',
  'signup.bt.carpetWashing.desc': 'Чистка ковров, килимов и дорожек',
  'signup.bt.shoeShine.desc': 'Чистка и уход за обувью',
  'signup.bt.sofaWashing.desc': 'Чистка диванов, кресел и мягкой мебели',
  'signup.bt.carWash.desc': 'Мойка, полировка и уход за автомобилями',
  'signup.bt.tailoring.desc': 'Пошив, ремонт одежды и швейные услуги',
  'signup.bt.barber.desc': 'Парикмахерская, барбершоп и салон красоты',
  'signup.bt.tailoring.desc': 'Портновские услуги, ремонт и пошив одежды',
  'signup.bt.barber.desc': 'Парикмахерская, барбершоп и салон красоты',

  // Account Statement Page (Cari Hesap Ekstresi)
  'accountStatement.title': 'Выписка по счету',
  'accountStatement.subtitle': 'Отслеживание дебиторской задолженности по клиентам',
  'accountStatement.selectCustomer': 'Выбрать клиента',
  'accountStatement.customerPlaceholder': 'Выберите клиента...',
  'accountStatement.searchCustomer': 'Поиск по имени, телефону или адресу...',
  'accountStatement.noCustomerSelected': 'Пожалуйста, выберите клиента',
  'accountStatement.currentBalance': 'Текущий баланс',
  'accountStatement.totalDebt': 'Общая задолженность',
  'accountStatement.totalPayments': 'Общие платежи',
  'accountStatement.transactions': 'Транзакции',
  'accountStatement.noTransactions': 'Для этого клиента не найдено записей транзакций',
  'accountStatement.date': 'Дата',
  'accountStatement.description': 'Описание',
  'accountStatement.debit': 'Дебет',
  'accountStatement.credit': 'Кредит',
  'accountStatement.balance': 'Баланс',
  'accountStatement.order': 'Заказ',
  'accountStatement.payment': 'Платеж',
  'accountStatement.loadError': 'Не удалось загрузить выписку по счету',
  'accountStatement.addPayment': 'Добавить платеж',
  'accountStatement.paymentAmount': 'Сумма платежа',
  'accountStatement.paymentMethod': 'Способ оплаты',
  'accountStatement.paymentNotes': 'Примечания (необязательно)',
  'accountStatement.recordPayment': 'Зарегистрировать платеж',
  'accountStatement.paymentSaved': 'Платеж зарегистрирован',
  'accountStatement.paymentError': 'Не удалось зарегистрировать платеж',
  'accountStatement.selectCustomerFirst': 'Сначала выберите клиента',
  'accountStatement.exportStatement': 'Экспортировать выписку',
  'accountStatement.exportStatementPDF': 'Скачать PDF',
  'accountStatement.noCustomersFound': 'Клиенты не найдены',
  'accountStatement.searchHint': 'Введите не менее 2 символов для поиска клиентов',
  'accountStatement.selectedCustomer': 'Выбранный клиент',
  'accountStatement.changeCustomer': 'Сменить клиента',
  'toast.productsLoadError': 'Ошибка загрузки продуктов',
  'toast.statsLoadError': 'Ошибка загрузки статистики',
  'toast.orderDetailsLoadError': 'Ошибка загрузки деталей заказа',
  'toast.orderLoadError': 'Ошибка загрузки заказа',
  'toast.deliveryBeforeToday': 'Дата доставки не может быть в прошлом',
  'toast.customerOpenOrders': 'У клиента {count} открытых заказов',
  'toast.customerDebt': 'У клиента долг в размере {amount}',
  'toast.customerSaved': 'Клиент сохранен',
  'toast.customerSaveError': 'Ошибка при сохранении клиента',
  'toast.customerUpdated': 'Клиент обновлен',
  'toast.customerUpdateError': 'Ошибка при обновлении клиента',
  'toast.customerExistingSelected': 'Выбран существующий клиент',
  'toast.productAddedToCart': 'Товар добавлен в корзину',
  'toast.productAdded': 'Товар добавлен',
  'toast.productDetailsUpdated': 'Детали товара обновлены',
  'toast.priceUpdated': 'Цена обновлена',
  'toast.selectAtLeastOneService': 'Выберите хотя бы одну услугу',
  'toast.selectCustomer': 'Пожалуйста, выберите клиента',
  'toast.addProduct': 'Пожалуйста, добавьте продукт',
  'toast.addressRequiredForDelivery': 'Для доставки на дом требуется адрес клиента',
  'toast.orderSaved': 'Заказ сохранен',
  'toast.orderSaveError': 'Ошибка при сохранении заказа',
  'toast.cardPaymentSuccess': 'Оплата картой прошла успешно!',
  'toast.cardPaymentError': 'Ошибка оплаты картой',
  'toast.paymentFailedTryAgain': 'Оплата не удалась. Пожалуйста, попробуйте еще раз.',
  'toast.paymentStatusCheckFailed': 'Не удалось проверить статус платежа.',
  'toast.customerPhoneNotFound': 'Телефон клиента не найден',
  'toast.whatsappSent': 'Сообщение WhatsApp отправлено! ✅',
  'toast.whatsappFailed': 'Не удалось отправить сообщение WhatsApp',
  'toast.orderUpdateError': 'Не удалось обновить заказ',
  'toast.searchError': 'Ошибка поиска',
  'toast.orderNotFound': 'Заказ не найден',
  'toast.editCancelled': 'Редактирование отменено',
  'toast.noEditPermission': 'У вас нет прав на редактирование прошлых заказов',
  'toast.selectAtLeastOneOperation': 'Выберите хотя бы одну операцию',
  'toast.tailorAddedToCart': 'Услуга портного добавлена в корзину',
  'toast.enterValidArea': 'Пожалуйста, введите корректную площадь',
  'toast.enterValidAmount': 'Введите корректную сумму',
  'toast.amountExceedsRemaining': 'Сумма не может превышать остаток',
  'toast.fillAllCardInfo': 'Пожалуйста, заполните все данные карты',
  'toast.invalidCardNumber': 'Неверный номер карты',
  'toast.invalidMonth': 'Неверный месяц (должен быть 1-12)',
  'toast.invalidYear': 'Неверный год',
  'toast.invalidCvc': 'Неверный CVC',
  
  // Z-Report
  'zReport.singleDay': 'Один день',
  'zReport.dateRange': 'Интервал дат',
  'zReport.startDate': 'Дата начала',
  'zReport.endDate': 'Дата окончания',
  'zReport.totalOrders': 'Всего заказов',
  'zReport.cancelledOrders': 'Отменённые заказы',
  'zReport.totalRevenue': 'Общая выручка',
  'zReport.paymentMethods': 'Способы оплаты',
  'zReport.cash': 'Наличные',
  'zReport.creditCard': 'Кредитная карта',
  'zReport.account': 'Счёт',
  'zReport.free': 'Бесплатно',
  'zReport.paidAtRegister': 'Оплачено при регистрации',
  'zReport.paidAtDelivery': 'Оплачено при доставке',
  'zReport.collectionDetails': 'Детали инкассации',
  'zReport.incoming': 'Входящие',
  'zReport.outgoing': 'Исходящие',
  'zReport.totalRegistered': 'Всего зарегистрировано',
  'zReport.expenses': 'Расходы',
  'zReport.noExpenses': 'Нет расходов',
  'zReport.totalExpenses': 'Всего расходов',
  'zReport.cancelledReceipts': 'Отменённые чеки',
  'zReport.reason': 'Причина',
  'zReport.noCancelled': 'Нет отменённых чеков',
  'zReport.totalCancelled': '{count} отменённых чеков',
  'zReport.serviceBreakdown': 'Разбивка по услугам',
  'zReport.loadError': 'Отчёт Z не загружен',
  'zReport.excelError': 'Ошибка экспорта Excel',
  'zReport.excelDownloaded': 'Excel скачан',
  'zReport.loading': 'Загрузка...',
  'zReport.todayOrders': 'Заказы сегодня',
  'zReport.registrationAndDelivery': 'Регистрация + Доставка',
  'zReport.orderPaidAtRegister': 'Заказ оплачен при регистрации',
  'zReport.orderPaidAtDelivery': 'Заказ оплачен при доставке',
  'zReport.accountCollections': 'Инкассация счёта',
  'zReport.totalCollection': 'Всего инкассировано',
  'zReport.bankTransfer': 'Банковский перевод',
  'zReport.cashRegister': 'Касса',
  'zReport.startingCash': 'Начальная касса',
  'zReport.dailyCashIncome': 'Входящие за сегодня',
  'zReport.cashToDeliver': 'Наличные к выдаче',
  'zReport.cashCalculation': '(Начало + Cash сегодня - Расходы)',

  // Недостающие общие ключи
  'common.allYears': 'Все годы',
  'common.autoDetected': 'Определено автоматически',
  'common.cancelled': 'Отменён',
  'common.clear': 'Очистить',
  'common.export': 'Экспорт',
  'common.exportExcel': 'Скачать Excel',
  'common.exportToExcel': 'Экспортировать в Excel',
  'common.filter': 'Фильтр',
  'common.items': 'Элементы',
  'common.loadError': 'Не удалось загрузить',
  'common.none': 'Нет',
  'common.ok': 'ОК',
  'common.paid': 'Оплачено',
  'common.print': 'Печать',
  'common.printDate': 'Дата печати',
  'common.searchError': 'Ошибка поиска',
  'common.searchResults': '(Результаты поиска)',
  'common.unit': 'Единица',
  'common.year': 'Год',

  // Выписка по счёту
  'accountStatement.allTime': 'За всё время',
  'accountStatement.customer': 'Клиент',
  'accountStatement.customerReceipts': 'Квитанции клиента',
  'accountStatement.noData': 'Выписки не найдены',
  'accountStatement.noReceipts': 'Квитанции не найдены',
  'accountStatement.payments': 'Платежи',
  'accountStatement.period': 'Период',
  'accountStatement.printStatement': 'Распечатать выписку',
  'accountStatement.receipts': 'Квитанции',
  'accountStatement.remaining': 'Остаток',
  'accountStatement.statement': 'Выписка по счёту',
  'accountStatement.totalPaid': 'Итого оплачено',

  // Объявление
  'announcement.trialInfo': 'Пробный период активен',
  'announcement.welcome': 'Добро пожаловать',

  // Атрибуты
  'attributes.addColor': 'Добавить цвет',
  'attributes.addDamage': 'Добавить повреждение',
  'attributes.addError': 'Не удалось добавить',
  'attributes.addStain': 'Добавить пятно',
  'attributes.color': 'Цвет',
  'attributes.deleteError': 'Не удалось удалить атрибут',
  'attributes.deleted': 'Атрибут удалён',
  'attributes.loadError': 'Не удалось загрузить атрибуты',
  'attributes.name': 'Название атрибута',
  'attributes.noAttributes': 'Атрибуты не заданы',
  'attributes.save': 'Сохранить',
  'attributes.saveError': 'Не удалось сохранить атрибуты',
  'attributes.saved': 'Атрибуты сохранены',
  'attributes.updateError': 'Не удалось обновить',
  'attributes.value': 'Значение',

  // Выписка клиента
  'customerStatement.receiptDelivered': 'Доставлено',
  'customerStatement.receiptOpen': 'Открыт',

  // Клиенты
  'customers.add': 'Добавить клиента',
  'customers.adres': 'Адрес',
  'customers.cannotDeleteWithOrders': 'Нельзя удалить клиента с заказами',
  'customers.import': 'Импорт',
  'customers.importTitle': 'Импорт клиентов',
  'customers.legacyHidden': 'Скрытый (Устаревший)',
  'customers.notFound': 'Клиент не найден',
  'customers.phoneMissing': 'Номер телефона отсутствует',
  'customers.telefon': 'Телефон',
  'customers.telefon2': 'Телефон 2',

  // Повреждения
  'damage.add': 'Добавить повреждение',
  'damage.description': 'Описание',
  'damage.location': 'Место',
  'damage.noPhoto': 'Нет фото',
  'damage.photo': 'Фото',
  'damage.saveError': 'Не удалось сохранить отчёт о повреждении',
  'damage.saved': 'Отчёт о повреждении сохранён',
  'damage.severity': 'Степень тяжести',
  'damage.title': 'Отчёт о повреждении',
  'damage.type': 'Тип повреждения',

  // Панель управления
  'dashboard.allTime': 'За всё время',
  'dashboard.referral.button': 'Копировать ссылку-приглашение',
  'dashboard.referral.desc': '+1 месяц, когда приглашённая компания зарегистрируется!',
  'dashboard.referral.title': 'Пригласить друзей',

  // Доставка
  'delivery.complete': 'Доставить',
  'delivery.deliveredItems': 'Доставленные позиции',
  'delivery.deliveredProducts': 'Доставленные товары',
  'delivery.error': 'Ошибка доставки',
  'delivery.loadError': 'Не удалось загрузить',
  'delivery.noOrders': 'Заказы не найдены',
  'delivery.orderDelivered': 'Заказ доставлен',
  'delivery.orderReady': 'Заказ готов',
  'delivery.searchOrder': 'Поиск заказа',
  'delivery.success': 'Доставка выполнена',
  'delivery.updateError': 'Не удалось обновить',

  // Список доставки
  'deliveryList.address': 'Адрес',
  'deliveryList.cancelButton': 'Отменить',
  'deliveryList.cancelConfirm': 'Подтвердить отмену',
  'deliveryList.cancelReasonPlaceholder': 'Причина отмены...',
  'deliveryList.cancelTitle': 'Отменить заказ',
  'deliveryList.complete': 'Завершить',
  'deliveryList.completed': 'Завершено',
  'deliveryList.delivered': 'Доставлено',
  'deliveryList.deliveryError': 'Ошибка доставки',
  'deliveryList.driver': 'Водитель',
  'deliveryList.items': 'Позиции',
  'deliveryList.messageError': 'Ошибка сообщения',
  'deliveryList.orderCancelled': 'Заказ отменён',
  'deliveryList.orderDelivered': 'Заказ доставлен',
  'deliveryList.pending': 'В ожидании',
  'deliveryList.phone': 'Телефон',
  'deliveryList.selectDriver': 'Выбрать водителя',
  'deliveryList.status': 'Статус',
  'deliveryList.title': 'Список доставки',
  'deliveryList.whatsappError': 'Ошибка WhatsApp',
  'deliveryList.whatsappSent': 'WhatsApp отправлен',

  // Страница доставки
  'deliveryPage.changeDeliveryType': 'Изменить тип доставки',
  'deliveryPage.changeToDelivery': 'Переключить на доставку',
  'deliveryPage.changeToDeliverySuccess': 'Переключено на доставку',
  'deliveryPage.changeToPickup': 'Переключить на самовывоз',
  'deliveryPage.changeToPickupError': 'Не удалось изменить',
  'deliveryPage.changeToPickupSuccess': 'Переключено на самовывоз',
  'deliveryPage.searchAll': 'Все',
  'deliveryPage.searchBy': 'Поиск по',
  'deliveryPage.searchName': 'Имя клиента',
  'deliveryPage.searchNamePlaceholder': 'Введите имя...',
  'deliveryPage.searchPhone': 'Телефон',
  'deliveryPage.searchPhoneBtn': 'Поиск по телефону',
  'deliveryPage.searchPlaceholder': 'Поиск...',
  'deliveryPage.searchReceipt': '№ квитанции',
  'deliveryPage.searchReceiptPlaceholder': 'Введите № квитанции...',

  // Водитель
  'driver.searchHint': 'Введите не менее 2 символов',
  'driver.searchPlaceholder': '№ квитанции, имя или телефон...',

  // Нижний колонтитул
  'footer.euServers': 'Серверы ЕС',
  'footer.gdpr': 'Соответствует GDPR',

  // Счета
  'invoices.downloading': 'Загрузка...',

  // Вход
  'login.credentialsTitle': 'Учётные данные',
  'login.demoAccount': 'Демо-аккаунт',
  'login.demoCredentials': 'Демо-данные',
  'login.demoLoaded': 'Демо загружен',
  'login.enterCredentials': 'Введите учётные данные',
  'login.firstLoginChangePin': 'Измените PIN при первом входе',
  'login.forget': 'Забыли пароль?',
  'login.invalidCredentials': 'Неверные учётные данные',
  'login.legalText': 'Юридический текст',
  'login.pin': 'PIN',
  'login.pinDescription': 'Введите 4-значный PIN',
  'login.pinRequired': 'Требуется PIN',
  'login.rememberMe': 'Запомнить меня',
  'login.saveCredentialsNote': 'Учётные данные сохранены безопасно',
  'login.signIn': 'Войти',
  'login.signingIn': 'Вход...',
  'login.tagline': 'Программа для химчистки — Умные решения для вашего бизнеса.',
  'login.tenantIdNotRemembered': 'ID компании не запомнен',
  'login.tenantRequired': 'Требуется ID компании',
  'login.tryForFree': 'Попробовать бесплатно',
  'login.username': 'Имя пользователя',
  'login.usernamePlaceholder': 'Введите имя пользователя...',
  'login.usernameRequired': 'Требуется имя пользователя',
  'login.version': 'Версия',

  // Меню
  'menu.driverPickup': 'Забор водителем',
  'menu.hardware': 'Оборудование',
  'menu.payment': 'Оплата',
  'menu.reportsCharts': 'Отчёты и графики',

  // Навигация
  'nav.logout': 'Выйти',
  'nav.user': 'Пользователь',

  // Уведомления
  'notifications.customMessage': 'Пользовательское сообщение',
  'notifications.failure': 'Ошибка отправки',
  'notifications.message': 'Сообщение',
  'notifications.preview': 'Предпросмотр',
  'notifications.schedule': 'Запланировать',
  'notifications.scheduleLater': 'Запланировать позже',
  'notifications.selectCustomer': 'Выбрать клиента',
  'notifications.selectDateTime': 'Выбрать дату и время',
  'notifications.selectTemplate': 'Выбрать шаблон',
  'notifications.send': 'Отправить',
  'notifications.sendError': 'Ошибка отправки',
  'notifications.sendNow': 'Отправить сейчас',
  'notifications.sending': 'Отправка...',
  'notifications.sent': 'Отправлено',
  'notifications.sms': 'SMS',
  'notifications.success': 'Уведомление отправлено',
  'notifications.whatsapp': 'WhatsApp',

  // Заказ
  'order.addProduct': 'Добавить товар',
  'order.amount': 'Сумма',
  'order.customer': 'Клиент',
  'order.discount': 'Скидка',
  'order.grandTotal': 'Итого',
  'order.homeDelivery': 'Доставка на дом',
  'order.newCustomer': 'Новый клиент',
  'order.price': 'Цена',
  'order.processing': 'Обработка...',
  'order.products': 'Товары',
  'order.quantity': 'Количество',
  'order.selectCustomer': 'Выбрать клиента',
  'order.selectProduct': 'Выбрать товар',
  'order.subtotal': 'Подытог',
  'order.tax': 'НДС',
  'order.title': 'Заказ',
  'order.total': 'Итого',
  'orderCreate.selectOperation': 'Выбрать операцию',
  'orderCreate.selectedOperations': 'Выбранные операции',

  // Оплата
  'payment.bank': 'Банковский перевод',
  'payment.collect': 'Инкассация',
  'payment.credit': 'Кредит',
  'payment.free': 'Бесплатно',
  'payment.paymentCare': 'Оплата счёта',
  'payment.paymentsSaved': 'Платежи сохранены',
  'payment.saveError': 'Не удалось сохранить платежи',
  'payment.saved': 'Платёж сохранён',
  'payment.split': 'Разделить платёж',

  // Заполнители
  'placeholder.customerAddress': 'Введите адрес...',
  'placeholder.customerEmail': 'Введите email...',
  'placeholder.customerName': 'Введите имя...',
  'placeholder.customerNotes': 'Введите примечания...',
  'placeholder.customerPhone': 'Введите телефон...',

  // Ценообразование
  'pricing.amount': 'Сумма',
  'pricing.enterPrice': 'Введите цену',
  'pricing.percent': 'Процент',

  // Товар
  'product.damage': 'Повреждение',
  'product.stain': 'Пятно',

  // Товары
  'products.addError': 'Не удалось добавить товар',
  'products.allCategories': 'Все категории',
  'products.delete': 'Удалить',
  'products.deleteConfirm': 'Подтвердить удаление',
  'products.deleteError': 'Не удалось удалить',
  'products.deleting': 'Удаление...',
  'products.editProduct': 'Редактировать товар',
  'products.loadError': 'Не удалось загрузить товары',
  'products.newProduct': 'Новый товар',
  'products.pieceCount': 'Количество штук',
  'products.productActive': 'Активный',
  'products.productAdded': 'Товар добавлен',
  'products.productCategory': 'Категория',
  'products.productDeleted': 'Товар удалён',
  'products.productInActive': 'Неактивный',
  'products.productName': 'Название товара',
  'products.productPrice': 'Цена',
  'products.productUpdated': 'Товар обновлён',
  'products.save': 'Сохранить',
  'products.saveError': 'Не удалось сохранить',
  'products.saved': 'Сохранено',
  'products.saving': 'Сохранение...',
  'products.searchProduct': 'Поиск товара',
  'products.updateError': 'Не удалось обновить',
  'products.updatePrice': 'Обновить цену',
  'products.updatePrices': 'Обновить цены',

  // Профиль
  'profile.changePassword': 'Изменить пароль',
  'profile.confirmPassword': 'Подтвердить пароль',
  'profile.currentPassword': 'Текущий пароль',
  'profile.email': 'Email',
  'profile.name': 'Имя',
  'profile.newPassword': 'Новый пароль',
  'profile.passwordChangeError': 'Не удалось изменить пароль',
  'profile.passwordChanged': 'Пароль изменён',
  'profile.passwordMismatch': 'Пароли не совпадают',
  'profile.phone': 'Телефон',
  'profile.role': 'Роль',
  'profile.save': 'Сохранить',
  'profile.saveError': 'Не удалось сохранить',
  'profile.saved': 'Сохранено',
  'profile.saving': 'Сохранение...',
  'profile.title': 'Профиль',

  // Квитанция
  'receipt.addressLabel': 'Адрес',
  'receipt.allYears': 'Все годы',
  'receipt.area': 'Площадь',
  'receipt.backButton': 'Назад',
  'receipt.buyCredits': 'Купить кредиты',
  'receipt.cancelled': 'Отменено',
  'receipt.cancelledBanner': 'Этот заказ был отменён',
  'receipt.cancelledBy': 'Отменено кем',
  'receipt.cancelledDate': 'Дата отмены',
  'receipt.cancelledReason': 'Причина отмены',
  'receipt.card': 'Карта',
  'receipt.cash': 'Наличные',
  'receipt.change': 'Сдача',
  'receipt.connect': 'Подключить',
  'receipt.connected': 'Подключено',
  'receipt.copyButton': 'Копировать',
  'receipt.copySend': 'Копировать и отправить',
  'receipt.copyTip': 'Копировать сообщение',
  'receipt.creditsFinished': 'Кредиты WhatsApp закончились!',
  'receipt.customer': 'Клиент',
  'receipt.customerInfo': 'Информация о клиенте',
  'receipt.customerName': 'Имя клиента',
  'receipt.deliveryDate': 'Дата доставки',
  'receipt.discount': 'Скидка',
  'receipt.discountedTotal': 'Итого со скидкой',
  'receipt.footerNote': 'Примечание',
  'receipt.freeOfCharge': 'Бесплатно',
  'receipt.generalTotal': 'Общая сумма',
  'receipt.goToWhatsAppPage': 'Перейти на страницу WhatsApp?',
  'receipt.grandTotal': 'Итого',
  'receipt.homeDelivery': 'Доставка на дом',
  'receipt.invalid': 'Недействительная квитанция',
  'receipt.items': 'Позиции',
  'receipt.label': 'Этикетка',
  'receipt.labelPrinted': 'Этикетка напечатана',
  'receipt.markAsDelivered': 'Отметить как доставленное',
  'receipt.markAsReady': 'Отметить как готовое',
  'receipt.markDeliveredError': 'Ошибка при отметке как доставленное',
  'receipt.markReadyError': 'Ошибка при отметке как готовое',
  'receipt.messageFailed': 'Не удалось отправить сообщение',
  'receipt.messageSendFailed': 'Отправка сообщения не удалась',
  'receipt.messageSent': 'Сообщение отправлено!',
  'receipt.new': 'Новая квитанция',
  'receipt.noCollection': 'Нет коллекции',
  'receipt.noReceiptFound': 'Квитанция не найдена',
  'receipt.notes': 'Примечания',
  'receipt.onlyProEnterprise': 'Только Pro/Enterprise',
  'receipt.openWhatsApp': 'Открыть WhatsApp',
  'receipt.orderMarkedDelivered': 'Заказ отмечен как доставленный',
  'receipt.orderMarkedReady': 'Заказ отмечен как готовый',
  'receipt.orderNumber': 'Номер заказа',
  'receipt.orderReceived': 'Заказ получен',
  'receipt.paid': 'Оплачено',
  'receipt.partialPayment': 'Частичная оплата',
  'receipt.paymentMethod': 'Способ оплаты',
  'receipt.phone': 'Телефон',
  'receipt.phoneNotFound': 'Номер телефона не найден',
  'receipt.piece': 'Штука',
  'receipt.preview': 'Предпросмотр',
  'receipt.printError': 'Ошибка печати',
  'receipt.printerConnectError': 'Не удалось подключить принтер',
  'receipt.productsInfo': 'Товары',
  'receipt.receiptInfo': 'Информация о квитанции',
  'receipt.remaining': 'Остаток',
  'receipt.remainingCredits': 'Оставшиеся кредиты',
  'receipt.reprint': 'Перепечатать',
  'receipt.scanQR': 'Сканировать QR-код',
  'receipt.searchAll': 'Все',
  'receipt.searchBy': 'Искать по',
  'receipt.searchError': 'Ошибка поиска',
  'receipt.searchName': 'Имя клиента',
  'receipt.searchPhone': 'Телефон',
  'receipt.searchReceipt': '№ квитанции',
  'receipt.searchReceiptPlaceholder': 'Введите № квитанции...',
  'receipt.searchTitle': 'Поиск квитанции',
  'receipt.selectAll': 'Выбрать все',
  'receipt.serviceSummary': 'Сводка услуг',
  'receipt.sessionNotFound': 'Сессия не найдена. Войдите снова.',
  'receipt.status': 'Статус',
  'receipt.thankYou': 'Спасибо',
  'receipt.thermalPrinter': 'Термопринтер',
  'receipt.thisReceiptCancelled': 'Эта квитанция была отменена',
  'receipt.unknownError': 'Неизвестная ошибка',
  'receipt.whatsappFeature': 'Функция WhatsApp',
  'receipt.whatsappNotConnected': 'WhatsApp не подключён!',
  'receipt.whatsappPreview': 'Предпросмотр WhatsApp',
  'receipt.whatsappPreviewDesc': 'Предпросмотр сообщения',
  'receipt.whatsappPreviewTitle': 'Предпросмотр',
  'receipt.year': 'Год',

  // Отчёты
  'reports.averageOrder': 'Средний заказ',
  'reports.dateRange': 'Период',
  'reports.ordersCount': 'Количество заказов',
  'reports.salesReport': 'Отчёт о продажах',
  'reports.totalSales': 'Общий объём продаж',

  // Список отчётов
  'reportsList.activeOnly': 'Только активные',
  'reportsList.amount': 'Сумма',
  'reportsList.cancelled': 'Отменено',
  'reportsList.customer': 'Клиент',
  'reportsList.date': 'Дата',
  'reportsList.delivered': 'Доставлено',
  'reportsList.noOrders': 'Нет заказов',
  'reportsList.payment': 'Оплата',
  'reportsList.phone': 'Телефон',
  'reportsList.receiptNumber': '№ квитанции',
  'reportsList.registered': 'Зарегистрировано',
  'reportsList.reprint': 'Перепечатать',
  'reportsList.searchPlaceholder': 'Поиск...',
  'reportsList.status': 'Статус',
  'reportsList.totalReceipts': 'Всего квитанций',
  'reportsList.totalRevenueExclCancelled': 'Общая выручка (без отменённых)',

  // Услуги
  'service.carpetShort': 'Ковёр',
  'service.dryCleaningShort': 'Чистка',
  'service.ironingShort': 'Глажка',
  'service.dyeingShort': 'Покраска',
  'service.shoeShineShort': 'Обувь',
  'service.tailoringShort': 'Пошив',
  'service.washingShort': 'Стирка',

  // Настройки
  'settings.africa': 'Африка',
  'settings.americas': 'Америка',
  'settings.asia': 'Азия',
  'settings.asiaPacific': 'Азия-Тихоокеанский регион',
  'settings.asianLanguages': 'Азиатские языки',
  'settings.autoConnect': 'Автоподключение',
  'settings.browserNotSupported': 'Браузер не поддерживается',
  'settings.callerId': 'ID звонящего',
  'settings.clickConnectButton': 'Нажмите Подключить',
  'settings.company': 'Компания',
  'settings.connectDeviceInfo': 'Информация об устройстве',
  'settings.cut': 'Обрезать',
  'settings.email': 'Email',
  'settings.europe': 'Европа',
  'settings.europeanLanguages': 'Европейские языки',
  'settings.expenses': 'Расходы',
  'settings.feedForward': 'Подача бумаги',
  'settings.formerSovietTurkic': 'Бывшие советские тюркские языки',
  'settings.genericEscPos': 'Универсальный ESC/POS',
  'settings.howToConnect': 'Как подключить',
  'settings.integrations': 'Интеграции',
  'settings.invoices': 'Счета',
  'settings.labelPrinter': 'Принтер этикеток',
  'settings.lastCall': 'Последний звонок',
  'settings.majorCurrencies': 'Основные валюты',
  'settings.menu': 'Меню',
  'settings.middleEast': 'Ближний Восток',
  'settings.middleEastAfricanLanguages': 'Языки Ближнего Востока и Африки',
  'settings.middleEastGulf': 'Залив Ближнего Востока',
  'settings.notifications': 'Уведомления',
  'settings.oceania': 'Океания',
  'settings.openDrawer': 'Открыть кассу',
  'settings.otherLanguages': 'Другие языки',
  'settings.paperWidth': 'Ширина бумаги',
  'settings.phonePlaceholder': 'Введите телефон...',
  'settings.popularLanguages': 'Популярные языки',
  'settings.printer': 'Принтер',
  'settings.printerConnect': 'Подключить принтер',
  'settings.printerConnected': 'Принтер подключён',
  'settings.printerConnection': 'Подключение принтера',
  'settings.printerDisconnect': 'Отключить принтер',
  'settings.printerModel': 'Модель принтера',
  'settings.printerNotConnected': 'Принтер не подключён',
  'settings.printerSettings': 'Настройки принтера',
  'settings.receiptVisibleOnReceipt': 'Видно в квитанции',
  'settings.reports': 'Отчёты',
  'settings.reverse': 'Реверс',
  'settings.reverseTest': 'Тест реверса',
  'settings.saveError': 'Не удалось сохранить настройки',
  'settings.saved': 'Настройки сохранены',
  'settings.selectDevice': 'Выбрать устройство',
  'settings.successful': 'Успешно',
  'settings.testPrint': 'Тестовая печать',
  'settings.testPrintHeader': 'Заголовок тестовой печати',
  'settings.testPrinted': 'Тестовая печать выполнена',
  'settings.tickets': 'Тикеты',
  'settings.turkey': 'Турция',
  'settings.webSerialNotSupported': 'Web Serial не поддерживается',
  'settings.webSerialSupported': 'Web Serial поддерживается',
  'settings.zReport': 'Z-отчёт',

  // Регистрация
  'signup.errors.companyCodeRequired': 'Код компании обязателен',
  'signup.errors.companyCodeTooShort': 'Код компании слишком короткий',
  'signup.errors.companyNameRequired': 'Название компании обязательно',
  'signup.errors.emailInvalid': 'Неверный email',
  'signup.errors.emailRequired': 'Email обязателен',
  'signup.errors.ownerNameRequired': 'Имя владельца обязательно',
  'signup.errors.signupFailed': 'Регистрация не удалась',
  'signup.referral.bonus': 'Реферальный бонус',
  'signup.referral.title': 'Код приглашения',

  // Статус
  'status.cancelled': 'Отменён',
  'status.delivered': 'Доставлен',
  'status.pending': 'В ожидании',
  'status.pickup_in_progress': 'Самовывоз в процессе',
  'status.pickup_pending': 'Самовывоз ожидает',
  'status.ready': 'Готов',
  'status.received': 'Получен',

  // Подписка
  'subscription.buyNow': 'Купить сейчас',
  'subscription.cancel': 'Отменить подписку',
  'subscription.contactSales': 'Связаться с продажами',
  'subscription.contactSupport': 'Связаться с поддержкой',
  'subscription.currentPlan': 'Текущий план',
  'subscription.currentUsage': 'Текущее использование',
  'subscription.daysLeft': 'дней осталось',
  'subscription.downgrade': 'Понижение',
  'subscription.endDate': 'Дата окончания',
  'subscription.expired': 'Истёк',
  'subscription.expiredOn': 'Истёк',
  'subscription.expiresOn': 'Истекает',
  'subscription.features': 'Функции',
  'subscription.loading': 'Загрузка подписки...',
  'subscription.monthly': 'Ежемесячно',
  'subscription.monthlyLimit': 'Месячный лимит',
  'subscription.noSubscription': 'Нет активной подписки',
  'subscription.payNow': 'Оплатить сейчас',
  'subscription.plan': 'План',
  'subscription.popular': 'Популярный',
  'subscription.pro': 'Pro',
  'subscription.renew': 'Продлить',
  'subscription.renewNow': 'Продлить сейчас',
  'subscription.startDate': 'Дата начала',
  'subscription.trial': 'Пробный',
  'subscription.trialDaysLeft': 'пробных дней осталось',
  'subscription.trialEnd': 'Конец пробного периода',
  'subscription.upgrade': 'Обновить',
  'subscription.yearly': 'Ежегодно',

  // Ателье
  'tailoring.addCustom': 'Добавить свой',
  'tailoring.astarDegisimi': 'Замена подкладки',
  'tailoring.belAyarı': 'Подгонка по талии',
  'tailoring.cancel': 'Отмена',
  'tailoring.cepDikimi': 'Пришить карман',
  'tailoring.dugmeDikme': 'Пришить пуговицу',
  'tailoring.fermuarDegisimi': 'Замена молнии',
  'tailoring.icon': 'Иконка',
  'tailoring.kolBoyu': 'Длина рукава',
  'tailoring.omuzAyarı': 'Подгонка плеч',
  'tailoring.operationName': 'Название операции',
  'tailoring.pacaBoyu': 'Ушивание проймы',
  'tailoring.price': 'Цена',
  'tailoring.save': 'Сохранить',
  'tailoring.sokukDikimi': 'Зашивание распоротого шва',
  'tailoring.yama': 'Заплатка',

  // Тикеты поддержки
  'tickets.closed': 'Закрыт',
  'tickets.translationError': 'Ошибка перевода',

  // Toast-уведомления
  'toast.cardPaymentFailed': 'Оплата картой не прошла. Попробуйте снова.',
  'toast.cardPaymentSuccessMsg': 'Оплата картой прошла успешно',
  'toast.connectionError': 'Ошибка подключения',
  'toast.connectionStatusError': 'Ошибка статуса подключения',
  'toast.customerAdded': 'Клиент добавлен',
  'toast.customerError': 'Ошибка клиента',
  'toast.deliveryDatePastError': 'Дата доставки уже прошла',
  'toast.demoDataDeleteError': 'Не удалось удалить демо-данные',
  'toast.demoDataDeleted': 'Демо-данные удалены',
  'toast.disconnectError': 'Ошибка отключения',
  'toast.logoTooLarge': 'Файл логотипа слишком большой',
  'toast.logoUploadError': 'Не удалось загрузить логотип',
  'toast.orderCreated': 'Заказ создан',
  'toast.orderError': 'Ошибка заказа',
  'toast.orderStatusUpdateError': 'Не удалось обновить статус',
  'toast.orderStatusUpdated': 'Статус обновлён',
  'toast.pinChangeError': 'Не удалось изменить PIN',
  'toast.pinChanged': 'PIN изменён',
  'toast.productAddedSimple': 'Товар добавлен',
  'toast.productError': 'Ошибка товара',
  'toast.qrError': 'Ошибка QR',
  'toast.qrGenerated': 'QR сгенерирован',
  'toast.statsError': 'Ошибка статистики',
  'toast.uploadingLogo': 'Загрузка логотипа...',
  'toast.userAddError': 'Не удалось добавить пользователя',
  'toast.userAdded': 'Пользователь добавлен',
  'toast.userDeleteError': 'Не удалось удалить пользователя',
  'toast.userDeleted': 'Пользователь удалён',
  'toast.userUpdateError': 'Не удалось обновить пользователя',
  'toast.userUpdated': 'Пользователь обновлён',
  'toast.usersLoadError': 'Не удалось загрузить пользователей',
  'toast.whatsappConnected': 'WhatsApp подключён',
  'toast.whatsappDisconnected': 'WhatsApp отключён',

  // Пользователи
  'users.delete': 'Удалить пользователя',
  'users.deleteError': 'Не удалось удалить',
  'users.deleteUserTitle': 'Удалить пользователя',
  'users.deletingUser': 'Удаление пользователя...',
  'users.loadError': 'Не удалось загрузить пользователей',
  'users.userDeleteError': 'Ошибка удаления пользователя',
  'users.userDeleted': 'Пользователь удалён',

  // WhatsApp
  'whatsapp.buyCredits': 'Купить кредиты',
  'whatsapp.connect': 'Подключить WhatsApp',
  'whatsapp.connected': 'Подключено',
  'whatsapp.creditPackages': 'Пакеты кредитов',
  'whatsapp.credits': 'Кредиты',
  'whatsapp.creditsRemaining': 'кредитов осталось',
  'whatsapp.disconnect': 'Отключить',
  'whatsapp.messageHistory': 'История сообщений',
  'whatsapp.messages': 'Сообщения',
  'whatsapp.noCredits': 'Нет кредитов',
  'whatsapp.orderDelivered': 'Заказ доставлен',
  'whatsapp.orderReady': 'Заказ готов',
  'whatsapp.preview': 'Предпросмотр',
  'whatsapp.receiptCreated': 'Квитанция создана',
  'whatsapp.save': 'Сохранить шаблон',
  'whatsapp.saved': 'Шаблон сохранён',
  'whatsapp.scanQR': 'Сканировать QR-код',
  'whatsapp.sendTest': 'Отправить тест',
  'whatsapp.status': 'Статус',
  'whatsapp.template': 'Шаблон',
  'whatsapp.templates': 'Шаблоны',
  'whatsapp.testFailed': 'Тест не прошёл',
  'whatsapp.testSent': 'Тест отправлен',

  // Z-отчёт
  'zReport.byEmployee': 'По сотруднику',
  'zReport.byProduct': 'По товару',
  'zReport.byService': 'По услуге',
  'zReport.cardPayments': 'Оплата картой',
  'zReport.cashIn': 'Приход',
  'zReport.cashOut': 'Расход',
  'zReport.cashPayments': 'Наличные платежи',
  'zReport.closingBalance': 'Закрывающий баланс',
  'zReport.creditPayments': 'Кредитные платежи',
  'zReport.custom': 'Пользовательский',
  'zReport.daily': 'Ежедневный',
  'zReport.endDate': 'Дата окончания',
  'zReport.freeOrders': 'Бесплатные заказы',
  'zReport.generateReport': 'Сформировать отчёт',
  'zReport.monthly': 'Ежемесячный',
  'zReport.newCustomers': 'Новые клиенты',
  'zReport.noData': 'Нет данных за период',
  'zReport.openingBalance': 'Открывающий баланс',
  'zReport.period': 'Период',
  'zReport.printReport': 'Распечатать отчёт',
  'zReport.returningCustomers': 'Постоянные клиенты',
  'zReport.selectDate': 'Выбрать дату',
  'zReport.serviceBreakdown': 'Разбивка по услугам',
  'zReport.startDate': 'Дата начала',
  'zReport.title': 'Z-отчёт',
  'zReport.todayRegistrations': 'Регистрации сегодня',
  'zReport.totalCollected': 'Итого собрано',
  'zReport.totalItems': 'Итого позиций',
  'zReport.totalOrders': 'Итого заказов',
  'zReport.totalRefunds': 'Итого возвратов',
  'zReport.totalRevenue': 'Общая выручка',
  'zReport.totalSales': 'Общий объём продаж',
  'zReport.transferPayments': 'Переводы',
  'zReport.weekly': 'Еженедельный',
  'zreport.card': 'Карта',
  'zreport.cash': 'Наличные',
  'zreport.date': 'Дата',
  'zreport.orders': 'Заказы',
  'zreport.print': 'Печать',
  'zreport.title': 'Z-отчёт',
  'zreport.total': 'Итого',

  'zReport.cashBoxStartNote': 'Начальный баланс кассы',
  'zReport.todayCashNote': 'Наличные получены сегодня',
  'zReport.branchCollectionsNote': 'Сборы своего + других филиалов',
  'zReport.dailyExpensesNote': 'Ежедневные расходы',
  'customerCard.balanceZero': 'Баланс уже равен нулю.',
  'customerCard.debtLabel': 'долг будет списан',
  'customerCard.creditLabel': 'кредит будет списан',
  'customerCard.resetConfirm': 'Баланс будет сброшен ({label}). Подтвердить?',
  'customerCard.resetSuccess': 'Баланс сброшен',
  'customerCard.resetError': 'Не удалось сбросить баланс',
  'customerCard.printTitle': 'Карточка клиента',
  'customerCard.heading': 'КАРТОЧКА КЛИЕНТА',
  'customerCard.tel1': 'ТЕЛ 1',
  'customerCard.tel2': 'ТЕЛ 2',
  'customerCard.address': 'АДРЕС',
  'customerCard.printButton': 'Печать карточки клиента',
  'customerCard.resetting': 'Сброс...',
  'customerCard.resetBalance': 'Сбросить баланс',
  'tailoring.loadError': 'Не удалось загрузить цены',
  'tailoring.nameRequired': 'Пожалуйста, введите название операции',
  'tailoring.invalidPrice': 'Пожалуйста, введите корректную цену',
  'tailoring.addSuccess': 'Новая операция пошива добавлена!',
  'tailoring.saveError': 'Ошибка сохранения',
  'tailoring.deleteConfirm': 'Вы уверены, что хотите удалить эту операцию?',
  'tailoring.deleteSuccess': 'Операция удалена',
  'tailoring.deleteError': 'Ошибка удаления',
  'tailoring.saveSuccess': 'Цены пошива сохранены!',
  'tailoring.addNewTitle': 'Добавить новую операцию пошива',
  'tailoring.operationNameLabel': 'Название операции',
  'tailoring.priceLabel': 'Цена',
  'tailoring.iconLabel': 'Значок (Emoji)',
  'tailoring.operationNamePlaceholder': 'Напр.: Пришивание воротника',
  'tailoring.savePricesHint': 'Нажмите Сохранить для сохранения цен',
  'tailoring.addCustomHint': 'Используйте кнопку + для добавления пользовательской операции',
  'reportsList.title': 'Список чеков',
  'reportsList.startDate': 'Дата начала',
  'reportsList.endDate': 'Дата окончания',
  'reportsList.search': 'Поиск',
  'reportsList.loading': 'Загрузка...',
  'reportsList.description': 'Перечислены все чеки, зарегистрированные или доставленные в указанный период',
  'reportsList.empty': 'Чеки за указанный период не найдены',
  'reportsList.changeDateRange': 'Выберите другой период',
  'reportsList.categoryBreakdown': 'Распределение по категориям',
  'reportsList.unknown': 'Неизвестно',
  'reportsList.cancelReason': 'Причина отмены:',
  'reportsList.excelDownloaded': 'Файл Excel загружен',
  'reportsList.excelError': 'Не удалось создать файл Excel',
  'reportsList.totalReceipt': 'Всего чеков',
  'reportsList.activeReceipt': 'Активные чеки',
  'reportsList.loadError': 'Не удалось загрузить список чеков',
  'reportsList.dateError': 'Дата начала не может быть позже даты окончания',
  'charts.revenue': 'Выручка',
  'charts.orders': 'Заказы',
  'charts.pieces': 'Количество единиц',
  'charts.receipts': 'Количество чеков',
  'charts.loadError': 'Не удалось загрузить данные',

  'customerStatement.selectDateRange': 'Выбрать период',
  'customerStatement.thisMonth': 'Этот месяц',
  'customerStatement.lastMonth': 'Прошлый месяц',
  'customerStatement.allTime': 'Все время',
  'customerStatement.startDate': 'Дата начала',
  'customerStatement.endDate': 'Дата окончания',
  'customerStatement.printPDF': 'Печать выписки (PDF)',
  'customerStatement.title': 'ВЫПИСКА ПО СЧЕТУ',
  'customerStatement.customerName': 'Имя клиента',
  'customerStatement.phone': 'Телефон',
  'customerStatement.address': 'Адрес',
  'customerStatement.openingBalance': 'Начальный остаток',
  'customerStatement.closingBalance': 'Конечный остаток',
  'customerStatement.description': 'Описание',
  'customerStatement.type': 'Тип',
  'customerStatement.debit': 'Дебет',
  'customerStatement.credit': 'Кредит (получено)',
  'customerStatement.total': 'ИТОГО',
  'customerStatement.cancelled': 'ОТМЕНЕНО',
  'customerStatement.payment': 'Платеж',
  'customerStatement.items': 'позиций',
  'customerStatement.noTransactions': 'Нет операций за выбранный период.',
  'customerStatement.statementDate': 'Дата выписки',

  'tailoring.subtitle': 'Здесь вы можете обновить цены на услуги портного',
  'tailoring.addNewDescription': 'Добавить пользовательский тип операции портного',
  'tailoring.add': 'Добавить',
  'tailoring.savePrices': 'Сохранить цены',
  'tailoring.default': 'По умолчанию',
  'tailoring.infoTitle': 'Информация',
  'tailoring.info1': 'После изменения цен нажмите "Сохранить цены"',
  'tailoring.info2': 'Кнопка "Новая операция" позволяет добавлять пользовательские типы операций',
  'tailoring.info3': 'Пользовательские операции можно удалить с помощью значка корзины',
  'tailoring.info4': 'Эти цены используются при создании заказов с услугой портного',
  'tailoring.info5': 'Вы можете установить отдельную цену для каждой операции портного',
  'tailoring.info6': 'Цены рассчитываются автоматически при добавлении в корзину',

  'hardware.title': 'Магазин оборудования',
  'hardware.subtitle': 'Чековые принтеры, принтеры этикеток и устройства Caller ID',
  'hardware.cart': 'Корзина',
  'hardware.infoTitle': 'Информация',
  'hardware.infoText': 'Эти аппаратные продукты в настоящее время доступны для покупки только в Турции. Для других стран они перечислены в информационных целях.',
  'hardware.myCart': 'Моя корзина',
  'hardware.cartEmpty': 'Корзина пуста',
  'hardware.vatSuffix': '+ НДС',
  'hardware.total': 'Итого',
  'hardware.checkout': 'Перейти к оплате',
  'hardware.receiptPrinters': 'Чековые принтеры',
  'hardware.receiptPrintersSubtitle': 'Термопринтеры 80мм с автообрезчиком',
  'hardware.compatibilityTitle': 'Совместимость CleandySoft',
  'hardware.receiptCompatText': 'Работает со всеми термопринтерами 80мм с автообрезчиком.',
  'hardware.labelPrinters': 'Принтеры этикеток',
  'hardware.labelPrintersSubtitle': 'Матричные принтеры, 76мм/57мм (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Протестированные модели',
  'hardware.labelCompatText': 'Протестировано для Epson TM-U220 и Bixolon SRP-270. Другие марки или модели могут иметь проблемы.',
  'hardware.callerIdTitle': 'Устройства Caller ID',
  'hardware.callerIdSubtitle': 'Определение входящих звонков клиентов',
  'hardware.compatibilityNote': 'Примечание о совместимости',
  'hardware.callerIdCompatText': 'Протестировано только для модели CIDShow 2 линии. Другие марки или модели могут работать, но не гарантируется.',
  'hardware.barcodeScanners': 'Сканеры штрих-кодов',
  'hardware.barcodeScannerSubtitle': 'USB-сканеры штрих-кодов и QR-кодов',
  'hardware.barcodeCompatText': 'Все 2D-сканеры штрих-кодов могут работать с CleandySoft. Сканеры в режиме USB HID поддерживаются автоматически.',
  'hardware.driverDownloads': 'Загрузки драйверов и программного обеспечения',
  'hardware.driverDownloadsText': 'Рекомендуется загрузить соответствующий драйвер перед подключением принтера.',
  'hardware.onlyTurkey': 'Этот продукт доступен для покупки только в Турции',
  'hardware.addedToCart': 'Добавлено в корзину!',
  'hardware.available': 'В наличии',
  'hardware.info': 'Инфо',
  'hardware.features': 'Характеристики',
  'hardware.addToCart': 'В корзину',
  'hardware.infoOnly': 'Только для информации',

  // ── tr.ts ile eşitleme: önceden eksik olan anahtarlar (ham anahtar / İngilizce görünüyordu) ──
  'changePin': 'Изменить PIN',
  'changingPin': 'Изменение...',
  'confirmPin': 'Подтвердите PIN',
  'currentPin': 'Текущий PIN',
  'newPin': 'Новый PIN',
  'pinDigits': '6 цифр',
  'charts.branchRevenue': 'Выручка по филиалам',
  'charts.cashCard': 'Наличные + Карта',
  'charts.cashCardAtDel': '💵 Наличные/Карта (при доставке):',
  'charts.cashCardAtReg': '💵 Наличные/Карта (при оформлении):',
  'charts.collectionSummary': 'Сводка поступлений',
  'charts.currentCollections': '📋 Погашение долгов:',
  'charts.customer': 'Клиент',
  'charts.dailyItems': 'График количества изделий по дням',
  'charts.dailyRevenue': 'График выручки по дням',
  'charts.graphicReports': 'Графические отчёты',
  'charts.itemCount': 'Количество изделий',
  'charts.noData': 'За этот период данных нет',
  'charts.periodSuffix': '(период)',
  'charts.regDelivery': '(Оформление + Доставка)',
  'charts.selectPeriod': 'Выберите другой период',
  'charts.top10Customers': 'Топ-10 клиентов по выручке',
  'charts.total': 'Итого',
  'charts.totalItems': 'Всего изделий',
  'charts.totalReceipts': 'Всего квитанций',
  'charts.totalRevenue': 'Общая выручка',
  'customers.totalOrders': 'Количество заказов',
  'customers.totalSpent': 'Всего потрачено',
  'damage.burn': 'Прожог',
  'damage.button': 'Проблема с пуговицей',
  'damage.buttonMissing': 'Нет пуговицы',
  'damage.color': 'Потеря цвета',
  'damage.delik': 'Дырка',
  'damage.fade': 'Выцветание',
  'damage.fray': 'Износ',
  'damage.hole': 'Дырка',
  'damage.lining': 'Подкладка',
  'damage.multiple': 'Повреждения (можно выбрать несколько)',
  'damage.none': 'Нет',
  'damage.other': 'Другое повреждение...',
  'damage.pembe': 'Розовое пятно',
  'damage.seam': 'Шов',
  'damage.stain': 'Пятно',
  'damage.tear': 'Разрыв',
  'damage.worn': 'Потёртость',
  'damage.zipper': 'Молния',
  'stain.pembe': 'Розовое',
  'dashboard.totalOrdersCard': 'Всего заказов',
  'delivery.actions': 'Действия',
  'delivery.customer': 'Клиент',
  'delivery.delivered': 'Доставлено',
  'delivery.deliveryDate': 'Дата доставки',
  'delivery.items': 'Товары',
  'delivery.markDelivered': 'Отметить как доставленный',
  'delivery.markReady': 'Отметить как готовый',
  'delivery.orderNumber': '№ заказа',
  'delivery.pending': 'В работе',
  'delivery.printReceipt': 'Печать квитанции',
  'delivery.ready': 'Готов',
  'delivery.status': 'Статус',
  'delivery.title': 'Управление доставкой',
  'delivery.total': 'Итого',
  'deliveryList.branchUpdated': 'Филиал доставки обновлён',
  'deliveryList.cancelError': 'Ошибка отмены',
  'deliveryList.changeBranch': 'Изменить филиал доставки',
  'deliveryList.homeDelivery': 'На адрес',
  'deliveryList.noBranch': 'Филиал не выбран',
  'deliveryList.noBranchAssigned': 'Филиал не назначен',
  'deliveryList.noPhone': 'Телефон клиента не найден',
  'deliveryList.pickup': 'приём',
  'deliveryList.selectBranch': 'Выберите филиал',
  'deliveryList.updateError': 'Не удалось обновить',
  'deliveryList.waRemind': 'Напомнить в WA',
  'deliveryList.whatsappFailed': 'Не удалось отправить WhatsApp',
  'deliveryList.whatsappTimeout': 'Время ожидания запроса WhatsApp истекло',
  'deliveryPage.itemsList': 'Детали заказа',
  'deliveryPage.quantity': 'Кол-во',
  'deliveryPage.searchEmptySubtitle': 'После поиска отобразятся заказы, готовые к доставке',
  'deliveryPage.searchEmptyTitle': 'Ищите по номеру квитанции, имени клиента или телефону',
  'deliveryPage.showItems': 'Показать товары',
  'deliveryPage.unknownProduct': 'Товар неизвестен',
  'error.customerNotCreated': 'Не удалось создать клиента',
  'error.customerNotDeleted': 'Не удалось удалить клиента',
  'error.customerNotFound': 'Клиент не найден',
  'error.customerNotUpdated': 'Не удалось обновить клиента',
  'error.customersNotLoaded': 'Не удалось загрузить клиентов',
  'error.databaseError': 'Ошибка базы данных',
  'error.expenseNotCreated': 'Не удалось создать расход',
  'error.expenseNotDeleted': 'Не удалось удалить расход',
  'error.expensesNotLoaded': 'Не удалось загрузить расходы',
  'error.forbidden': 'У вас нет прав для этого действия',
  'error.invalidRequest': 'Некорректный запрос',
  'error.orderNotCreated': 'Не удалось создать заказ',
  'error.orderNotUpdated': 'Не удалось обновить заказ',
  'error.ordersNotLoaded': 'Не удалось загрузить заказы',
  'error.paymentFailed': 'Оплата не прошла',
  'error.phoneAlreadyExists': 'Этот номер телефона уже зарегистрирован! Пожалуйста, используйте другой номер.',
  'error.productNotCreated': 'Не удалось создать товар',
  'error.productNotUpdated': 'Не удалось обновить товар',
  'error.productsNotLoaded': 'Не удалось загрузить товары',
  'error.serverError': 'Ошибка сервера',
  'error.tenantIdRequired': 'Требуются данные сессии',
  'error.tenantIdRequiredLogin': 'Требуются данные сессии. Пожалуйста, войдите в систему.',
  'error.unauthorized': 'Несанкционированный доступ',
  'error.unknownError': 'Произошла неизвестная ошибка',
  'error.userNotCreated': 'Не удалось создать пользователя',
  'error.userNotUpdated': 'Не удалось обновить пользователя',
  'error.usersNotLoaded': 'Не удалось загрузить пользователей',
  'errorBoundary.forbidden': 'Доступ запрещён',
  'errorBoundary.forbiddenDetails': 'У вас недостаточно прав для выполнения этого действия.',
  'errorBoundary.goHome': 'На главную',
  'errorBoundary.pageNotFound': 'Страница не найдена',
  'errorBoundary.pageNotFoundDetails': 'Запрашиваемая страница не существует или была перемещена.',
  'errorBoundary.persistentIssue': 'Если проблема сохраняется, обратитесь в службу поддержки.',
  'errorBoundary.reload': 'Обновить страницу',
  'errorBoundary.serverError': 'Ошибка сервера',
  'errorBoundary.serverErrorDetails': 'На сервере произошла ошибка. Пожалуйста, повторите попытку позже.',
  'errorBoundary.technicalDetails': 'Технические детали',
  'errorBoundary.unauthorized': 'Несанкционированный доступ',
  'errorBoundary.unauthorizedDetails': 'У вас нет доступа к этой странице.',
  'errorBoundary.unknownError': 'Произошла ошибка',
  'menu.barber': 'Парикмахерская',
  'menu.carWash': 'Автомойка',
  'menu.referral': 'Пригласить',
  'service.barber': 'Парикмахерская',
  'service.dryCleaningFull': 'Химчистка',
  'notifications.subtitle': 'Настройте уведомления по SMS и WhatsApp',
  'notifications.title': 'Уведомления SMS/WhatsApp',
  'order.addressIcon': '📍 Адрес',
  'order.addressRequiredForDelivery': 'Для доставки на адрес необходимо указать адрес',
  'order.amountPaid': 'Оплаченная сумма',
  'order.balanced': 'Нет задолженности',
  'order.cancel': 'Отмена',
  'order.card': 'Банковская карта',
  'order.cash': 'Наличные',
  'order.createOrder': 'Создать заказ',
  'order.credit': 'В долг',
  'order.debt': 'Долг',
  'order.deliveryDate': 'Дата доставки',
  'order.discountOptional': 'Скидка (необязательно)',
  'order.discountPercent': 'Скидка ({percent}%)',
  'order.discountRate': 'Скидка',
  'order.discountSummary': 'Итог по скидке',
  'order.enterDiscountRate': 'Введите размер скидки (0-100):',
  'order.homeDeliveryIcon': '🏠 Доставка на адрес',
  'order.homeDeliveryShort': 'Доставка на адрес',
  'order.newPrice': 'Новая цена',
  'order.notes': 'Примечания',
  'order.notesOptional': 'Примечания (необязательно)',
  'order.notesPlaceholder': 'Дополнительная информация, особые пожелания...',
  'order.payment': 'Оплата',
  'order.paymentMethod': 'Способ оплаты',
  'order.priceAndDiscountEdit': 'Изменение цены и скидки',
  'order.quickDiscount': 'Быстрые кнопки скидки',
  'order.receivable': 'Переплата',
  'order.remainingBalance': 'Остаток',
  'order.selectPaymentMethod': 'Выберите способ оплаты',
  'order.totalDebt': 'Общий долг',
  'order.totalPayments': 'Всего оплачено',
  'order.totalWithQuantity': 'Итого ({count} шт.)',
  'orderCreate.pickupFromAddress': 'Водитель заберёт с адреса',
  'payment.addPayment': 'Добавить оплату',
  'payment.amount': 'Сумма оплаты',
  'payment.amountToPay': 'Сумма к оплате',
  'payment.bankTransfer': 'Банковский перевод',
  'payment.complete': 'Завершить оплату',
  'payment.completed': 'Завершено',
  'payment.confirm': 'Подтвердить оплату',
  'payment.enterAmount': 'Введите сумму оплаты',
  'payment.failed': 'Оплата не прошла',
  'payment.madePayments': 'Произведённые оплаты',
  'payment.method': 'Способ оплаты',
  'payment.paid': 'Оплачено',
  'payment.partial': 'Частичная оплата',
  'payment.pending': 'Ожидает',
  'payment.posConfirm': 'После получения подтверждения оплаты на POS-терминале нажмите кнопку «Подтвердить».',
  'payment.posInstructions': 'Пожалуйста, примите оплату у клиента через POS-терминал.',
  'payment.posPayment': 'Оплата картой (POS-терминал)',
  'payment.remaining': 'Остаток',
  'payment.selectMethod': 'Выберите способ оплаты',
  'payment.splitPayment': 'Раздельная оплата',
  'payment.status': 'Статус оплаты',
  'payment.success': 'Оплата прошла успешно',
  'profile.subscriptionBilling': 'Подписка и оплата',
  'receipt.labelConfirmDesc': 'Квитанция оформлена. Отправить этикетку на принтер этикеток?',
  'receipt.labelConfirmTitle': 'Напечатать этикетку?',
  'receipt.labelNo': 'Нет',
  'receipt.labelYes': 'Да, печатать',
  'reportsList.created': 'Создан',
  'reportsList.deliveredThisPeriod': '📦 Оформлены ранее, доставлены в этом периоде ({count} квит.)',
  'reportsList.registeredThisPeriod': '📝 Оформлены в этом периоде ({count} квит.)',
  'settings.addDemoProducts': 'Добавить демо-товары',
  'settings.adding': 'Добавление...',
  'settings.afrika': 'Африка',
  'settings.companyInfo': 'Информация о компании',
  'settings.currencyPositionPreview': 'Символ {position}: {example}',
  'settings.delete': 'Удалить',
  'settings.deleteButton': 'Удалить демо-данные',
  'settings.deleteDemoDataDesc': 'Это действие безвозвратно удалит всех демо-клиентов, заказы и записи об оплатах.',
  'settings.demoProducts': 'Демо-товары',
  'settings.demoProductsDescription': 'Добавляет демо-товары с заданными ценами',
  'settings.footerPlaceholder': 'Текст нижней части',
  'settings.footerText': 'Текст внизу квитанции',
  'settings.footerTextHelp': 'Короткое сообщение внизу квитанции',
  'settings.headerInfo': 'Верхняя строка',
  'settings.headerInfoPlaceholder': 'напр.: Химчистка и глажка',
  'settings.logo': 'Логотип',
  'settings.orderCreated': 'Заказ создан',
  'settings.orderDelivered': 'Заказ доставлен',
  'settings.orderReady': 'Заказ готов',
  'settings.previewItem1': 'Товар 1',
  'settings.previewItem2': 'Товар 2',
  'settings.previewTotal': 'ИТОГО',
  'settings.receiptNoteHelp': 'Подробные условия и положения',
  'settings.receiptPreview': 'Предпросмотр квитанции',
  'settings.showTax': 'Показывать НДС',
  'settings.smsTemplates': 'Шаблоны SMS-сообщений',
  'settings.whatsappTemplates': 'Шаблоны сообщений WhatsApp',
  'signup.companyDetails': 'Данные компании',
  'signup.fields.companyCode': 'Код компании',
  'signup.fields.companyName': 'Название компании',
  'signup.fields.country': 'Страна',
  'signup.fields.email': 'Адрес эл. почты',
  'signup.fields.ownerName': 'Имя и фамилия',
  'signup.fields.phone': 'Номер телефона',
  'signup.haveAccount': 'Уже есть аккаунт? Войдите',
  'signup.placeholders.companyCode': 'напр.: cleanpro',
  'signup.placeholders.companyName': 'напр.: Химчистка CleanPro',
  'signup.placeholders.email': 'напр.: ivan@cleanpro.com',
  'signup.placeholders.ownerName': 'напр.: Иван Иванов',
  'signup.placeholders.phone': 'напр.: +7 900 123-45-67',
  'subscription.autoRenewActive': '✅ Автопродление активно — следующий платёж:',
  'subscription.autoRenewBadge': '🔄 Подписка с автопродлением',
  'subscription.autoRenewInfo': '🔄 Ваша подписка продлевается автоматически. Перед продлением вы получите уведомление по эл. почте.',
  'subscription.billingAutoSave': '💾 Ваши данные сохраняются автоматически и будут подставлены при следующей оплате',
  'subscription.billingDesc': 'Введите платёжные реквизиты и перейдите к оплате',
  'subscription.billingInfoSaved': '✅ Платёжные реквизиты сохранены',
  'subscription.billingLangLabel': 'Язык счёта',
  'subscription.branchCashManagement': 'Отдельная касса для каждого филиала',
  'subscription.branchesIncluded': 'До 2 филиалов включено',
  'subscription.cancelAnytime': 'ℹ️ Вы можете отменить подписку в любой момент.',
  'subscription.cancelSubBtn': '❌ Отменить подписку',
  'subscription.cardAtPayment': '💳 Оплата будет произведена на странице оплаты с использованием данных вашей карты.',
  'subscription.cardInfoTitle': 'Данные карты вводятся на странице оплаты',
  'subscription.changePlan': '💳 Изменить',
  'subscription.changePlanIntl': '🏓 Изменить',
  'subscription.comparePlans': 'Сравните тарифы',
  'subscription.crossBranchDelivery': 'Доставка между филиалами',
  'subscription.customersLabel': 'Клиенты',
  'subscription.emailNotifBadge': '💳 Уведомление по эл. почте перед продлением',
  'subscription.enterBillingInfo': '📄 Пожалуйста, заполните платёжные реквизиты',
  'subscription.enterpriseOnlyDesc': 'Управление филиалами доступно только в тарифе Enterprise. Чтобы управлять несколькими филиалами, вести отдельную кассу и доставку между филиалами, перейдите на Enterprise.',
  'subscription.enterpriseOnlyTitle': 'Требуется тариф Enterprise',
  'subscription.expiringDays': 'Срок вашей подписки истекает через {days} дн. Пожалуйста, продлите её, чтобы сервис работал без перерывов.',
  'subscription.expiryLabel': 'Действует до:',
  'subscription.extendBtn': 'Продлить подписку',
  'subscription.extendSubBtn': '💳 Продлить подписку',
  'subscription.extendedBy1m': 'Будет продлено на 1 месяц',
  'subscription.extendedBy1y': 'Будет продлено на 1 год',
  'subscription.faq1a': 'При смене тарифа вы сразу получаете доступ к новым функциям. Оплаченный срок (месяц или год) добавляется к текущему сроку подписки.',
  'subscription.faq1q': 'Что происходит при смене тарифа?',
  'subscription.faq2a': 'Если вы отмените подписку, сервис будет доступен до конца текущего периода. Ваши данные хранятся 15 дней.',
  'subscription.faq2q': 'Что будет, если я отменю подписку?',
  'subscription.faq3a': 'Оплата принимается только кредитными и дебетовыми картами. Оплата банковским переводом недоступна.',
  'subscription.faq3q': 'Какие способы оплаты вы принимаете?',
  'subscription.faq4a': 'В течение 15 дней после создания аккаунта вы можете бесплатно пользоваться всеми функциями. По окончании пробного периода необходимо приобрести подписку.',
  'subscription.faq4q': 'Как работает 15-дневный пробный период?',
  'subscription.faqTitle': 'Часто задаваемые вопросы',
  'subscription.manageBilling': 'Управление счетами',
  'subscription.odealPOS': 'Интеграция с POS Ödeal (по желанию)',
  'subscription.paymentRequiredBadge': '💳 Для продления требуется оплата',
  'subscription.planWord': 'тариф',
  'subscription.purchasePlanTitle': 'Покупка тарифа {name}',
  'subscription.receiptsLabel': 'Квитанции',
  'subscription.referralDesc': 'Когда приглашённый вами друг зарегистрируется и станет участником, вы получите 1 дополнительный месяц! Одного приглашения недостаточно.',
  'subscription.referralShare': 'Поделиться ссылкой-приглашением',
  'subscription.referralTitle': 'Порекомендуйте друзьям',
  'subscription.renewsInDays': 'Ваша текущая подписка будет продлена через {days} дн.',
  'subscription.saveInfoBtn': '💾 Сохранить данные',
  'subscription.saveInfoHint': 'Будет подставлено автоматически при следующей оплате',
  'subscription.savedBillingInfo': '📄 Ваши сохранённые платёжные реквизиты',
  'subscription.selectBtn': 'Выбрать',
  'subscription.subCancelledBadge': '⚠️ Подписка отменена',
  'subscription.subInfoTitle': '📋 Информация о подписке',
  'subscription.subIsMonthly': '✅ Это оформление месячной подписки.',
  'subscription.subIsYearly': '✅ Это оформление годовой подписки.',
  'subscription.subtitle': 'Управляйте тарифом и настройками оплаты',
  'subscription.supportTimeLabel': 'Срок ответа поддержки',
  'subscription.switchPlan': '💳 Перейти на тариф',
  'subscription.switchPlanIntl': '🏓 Перейти на тариф',
  'subscription.taxOffice': 'Налоговая инспекция',
  'subscription.totalAmountLabel': 'Общая сумма',
  'subscription.trial15d': '15-дневный пробный период',
  'subscription.unlimitedUsers': 'Неограниченное число пользователей',
  'subscription.upgradeBtn': 'Повысить',
  'subscription.upgradeToEnterprise': 'Перейти на Enterprise',
  'subscription.usageTitle': 'Использование и лимиты за этот месяц',
  'subscription.usersLabel': 'Пользователи',
  'subscription.vatNote': '+ НДС (20%)',
  'subscription.warning': 'Предупреждение о подписке',
  'subscription.yearlyFreeBtn': '🎉 Годовая (2 месяца бесплатно!)',
  'subscription.yearlyFreeNote': '🎉 При годовой оплате 2 месяца бесплатно!',
  'subscription.yearlySavings': '💡 Экономия 17% при годовой оплате',
  'toast.carpetAddedToCart': 'Ковёр добавлен в корзину',
  'toast.carpetsAddedToCart': 'Ковры добавлены в корзину',
  'toast.enterValidValue': 'Введите корректное значение',
  'toast.orderSetToReady': 'Заказ отмечен как готовый',
  'toast.paymentStatusCheckError': 'Не удалось проверить статус оплаты. Пожалуйста, проверьте свой счёт.',
  'toast.paymentStatusCheckErrorShort': 'Не удалось проверить статус оплаты.',
  'toast.selectPaymentMethodFirst': 'Сначала выберите способ оплаты',
  'toast.statusUpdateError': 'Не удалось обновить статус',
  'whatsapp.deliveryReminder': '{customerName}, вы не забираете заказ № {orderNumber} уже {daysAgo} дн. Пожалуйста, заберите его как можно скорее.',
  'whatsapp.receiptMessage': 'Уважаемый(ая) {customerName}, ваш заказ № {orderNumber} готов и ожидает выдачи.',
  'whatsapp.thankYou': 'Спасибо!',
  'zReport.cariCollection': 'Погашение долгов',
  'zReport.collectedItems': 'Оплаченные заказы',
  'zReport.deliveryCard': 'Получено картой при доставке',
  'zReport.deliveryCash': 'Получено наличными при доставке',
  'zReport.discountNotReflected': 'Суммы рассчитаны по чистым ценам с учётом скидки.',
  'zReport.infoNote': 'Только для информации',
  'zReport.mealCard': 'Карта питания',
  'zReport.onDelivery': 'Оплата при доставке',
  'zReport.orderCollections': 'Поступления по заказам',
  'zReport.paymentDetails': 'Детали поступлений',

  // Ön eksiz genel anahtarlar (Ürünler/Şablonlar pencerelerinde ham anahtar basılıyordu)
  'cancel': 'Отмена',
  'save': 'Сохранить',
  'update': 'Обновить',
  'create': 'Создать',
  'loading': 'Загрузка...',
  'back': 'Назад',
  'smsSettingsRequired': 'Перед отправкой тестового SMS настройте и сохраните параметры SMS выше',
};